export const API_URL = process.env.REACT_APP_API_URL;
export const MAP_KEY: any = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const STORAGE = "arrow-cmms";
export const KEYS = {
  AUTH_ACCESS: "arrow-auth-access",
  AUTH_REFRESH: "arrow-auth-refresh",
  AUTH_SESSION: "arrow-auth-session",
  EDIT_PANELS: {
    PICK_DESIGN: "pick-design",
    CHANGE_COLOR: "change-color",
    ADD_TEXT: "add-text",
    JERSEY_NUMBER: "jersey-number",
    ADD_IMAGE: "add-image",
    ROSTER: "roster",
    QUANTITY_AND_SIZE: "quantity-and-size",
    READY_TO_GO: "ready-to-go",
  },
};

export const URLS = {
  AUTH: {
    LOGIN: "/login",
    //LOGIN: API_URL + "/APIAuthenticate/LoginWithPermission",
    REGISTER: "/register",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password/:email",
  },
  HOME: "/",
  PROFILE: "/profile",
  MY_DASHBOARD: "/my-dashboard",
  FACILITIES: "/facilities",
  FACILITY_DETAILS: (id: string = "") => {
    return id === "" ? `/facilities/:id` : `/facilities/${id}`;
  },
  ASSETS: "/assets",
  ASSETS_DETAILS: (id: string = "") => {
    return id === "" ? `/assets/:id` : `/assets/${id}`;
  },
  ASSETS_MOVE_MAP_VIEW: (id: string = "") => {
    return id === "" ? `/assets/move-history-map/:id` : `/assets/move-history-map/${id}`;
  },
  WIPASSETS: "/wipassets",
  WARRANTIES: "/warranties",
  LEASE_ASSETS: "/lease-assets",
  DEPRECIATION: "/depreciation",
  WORK_REQUEST: "/work-request",
  WORK_REQUEST_DETAILS: (id: string = "") => {
    return id === "" ? `/work-request/:id` : `/work-request/${id}`;
  },
  MAINTENANCE_CALENDER: "/maintenance-calender",
  WORK_ORDERS: "/work-order",
  WORK_ORDER_DETAILS: (id: string = "") => {
    return id === "" ? `/work-order/:id` : `/work-order/${id}`;
  },
  CHECKLISTS: "/checklists",
  CHECKLIST_CREATE: (id: string = "") => {
    return id === "" ? `/checklists/:id` : `/checklists/${id}`;
  },
  INVENTORY: {
    CYCLE_COUNT: "/inventory/cycle-count",
    RECEIVE_STOCK: "/inventory/receive-stock",
    STOCK_PICKING_OLD: "/inventory/stock-picking-old",
    STOCK_PICKING: "/inventory/stock-picking",
    STOCK_ADJUSTMENT: "/inventory/stock-adjustment",

    SPEAR_PARTS: {
      LIST: "/inventory/spare-parts",
      DETAILS: (id: string = "") => {
        return id === ""
          ? `/inventory/spare-parts/:id`
          : `/inventory/spare-parts/${id}`;
      },
    },
  },
  PURCHASING: {
    REQUEST: {
      LIST: "/purchase/request",
    },
    ORDER: "/purchase/order",
    STOCK: "/purchase/stock",
  },
  VENDORS: "/vendors",
  USERS: "/users",
  USERS_SETTING: "/users/settings",
  USER_TYPE_PERMISSION: (id: string = "") => {
    return id === "" ? `/users/permissions/:id` : `/users/permissions/${id}`;
  },
  ADOPTION_DASHBOARD: "/adoption-dashboard",
  MANAGER_DASHBOARD: "/manager-dashboard",
  REPORTS: "/reports",
  REPORTS_ASSETS: "/reports/report-assets",
  REPORTS_DEPRECIATION: "/reports/report-depreciation",
  REPORTS_STOCK_TRANSACTION: "/reports/report-stock-transaction",
  REPORTS_STOCK_INVENTORY_BALANCE: "/reports/report-stock-inventory-balance",
  REPORTS_ASSETS_UPTIME: "/reports/assets-uptime",
  REPORTS_ASSETS_TIME_COST: "/reports/assets-time-cost",
  REPORTS_TOTAL_MTTR: "/reports/total-mttr",
  REPORTS_MTBF: "/reports/mtbf",
  REPORTS_WARRANTIES: "/reports/warranties",
  REPORTS_AUDITOR: "/reports/auditor",
  REPORTS_LOW_STOCK: "/reports/low-stock",
  REPORTS_SPARE_PARTS_USAGE: "/reports/spare-parts-usage",
  REPORTS_STOCK_ADJUSTMENT: "/reports/stock-adjustment",
  REPORTS_CLOSED_TASKS: "/reports/closed-tasks",
  SETTINGS: "/settings",
  SETTINGS_SAGE_CONNECTOR: "/settings/sage-connector",
  SETTINGS_BILL_COM_CONNECTOR: "/settings/bill-com-connector",
  SETTINGS_BILL_COM_MASTER_DATA_SYNC: "/settings/bill-com-master-data-sync",
  SETTINGS_SAGE_MASTER_DATA_SYNC: "/settings/sage-master-data-sync",
  SETTINGS_SAGE_ASSET_GROUP_MASTER: "/settings/sage-asset-group-master",
  SETTINGS_SAGE_ASSETS_MAPPING: "/settings/sage-assets-mapping",
  SETTINGS_SAGE_ASSETS_INVENTORY_MAPPING:
    "/settings/sage-assets-inventory-mapping",
  SETTINGS_SAGE_OTHER_MAPPING: "/settings/sage-other-mapping",
  SETTINGS_SAGE_ASSETS_EXPENSES_MAPPING: "/settings/sage-assets-expenses-mapping",
  SETTINGS_USER_FACILITY: "/settings/master-facility",
  SETTINGS_USER_SERVICE_TECH: "/settings/master-service-tech",
  SETTINGS_USER_GROWER: "/settings/master-grower",
  SETTINGS_USER_DEPARTMENT: "/settings/master-department",
  ACCOUNT: "/account",
};

export const APIS = {
  AUTH: {
    LOGIN: API_URL + "/APIAuthenticate",
    LOGIN_WITH_PERMISSION: API_URL + "/APIAuthenticate/LoginWithPermission",
    LOGOUT: API_URL + "/logout",
    //FORGOT_PASSWORD: API_URL + "/forgot/password",
    FORGOT_PASSWORD: API_URL + "/APIAuthenticate/ForgetPassword",
    RESET_PASSWORD: API_URL + "/set/password",
    CHANGE_PASSWORD: API_URL + "/users/password",
    REGISTRATION: API_URL + "/register",
    AVATAR: API_URL + "/users/avatar",
    REFRESH_TOKEN: API_URL + "/APIAuthenticate/RefreshToken"
  },
  USER: {
    GET_DESIGNS: API_URL + "/design/list",
    SAVE_DESIGN: API_URL + "/design/create",
    UPDATE_DESIGN: API_URL + "/design/update",
    IMAGE_LIST: API_URL + "/user-image/list",
    IMAGE_UPLOAD: API_URL + "/user-image/create",
    IMAGE_DELETE: API_URL + "/user-image/delete",
    SAVE_TEAM_USER_MAPPING: API_URL + "/User/SaveTeamUserMapping",
    GET_ALL_API_ENDPOINTS: API_URL + "/APIAuthenticate/GetAllApiEndpoints",
    SAVE_USER_MODULE_BUNDLE: API_URL + "/APIAuthenticate/SaveUserModuleBundle",
    SAVE_USER_MODULE: API_URL + "/APIAuthenticate/SaveUserModule",
    DELETE_USER_MODULE: API_URL + "/APIAuthenticate/DeleteUserModule",
    LoginWithPermissions: API_URL + "/APIAuthenticate/LoginWithPermissions",

    GET_USER_TYPE_BY_ID: API_URL + "/UserType/GetUserTypeByID",
    GET_USER_TYPES: API_URL + "/UserType/GetUserTypes",
    SAVE_USER_TYPE: API_URL + "/UserType/SaveUserType",
    DELETE_USER_TYPE: API_URL + "/UserType/DeleteUserType",

    SAVE_USER: API_URL + "/User/SaveUser",
    GET_USER: API_URL + "/User/GetUser",
    GET_USER_MODULES: API_URL + "/UserModule/GetUserModules",
    GET_USER_MODULE_BY_ID: API_URL + "/UserModule/GetUserModuleByID",
    SAVE_USER_MODULE_API_ENTITY: API_URL + "/APIAuthenticate/SaveUserModuleApiEntity",
    DELETE_USER: API_URL + "/User/DeleteUser",
    FORGET_PASSWORD: API_URL + "/User/ForgetPassword",
  },
  FACILITY: {
    GET_FACILITY_LIST: API_URL + "/Facility/GetFacilityList",
    GET_FACILITY_DETAILS: API_URL + "/Facility/GetFacilityByID",
    SAVE_FACILITY: API_URL + "/Facility/SaveFacility",
    SAVE_FACILITY_MASTER: API_URL + "/Facility/SaveFacilityMaster",
    SAVE_TEAM: API_URL + "/Facility/SaveTeam",
    SAVE_SERVICE_TECH_MASTER: API_URL + "/Facility/SaveServiceTechMaster",
    DELETE_FACILITY: API_URL + "/Facility/DeleteFacility",
    DELETE_FACILITY_MANAGER: API_URL + "/Facility/DeleteFacilityManager",
    DELETE_SERVICE_TECH: API_URL + "/Facility/DeleteServiceTech",
    DELETE_TEAM: API_URL + "/Facility/DeleteTeam",

    GET_PROCESSING_FACILITY_LIST: API_URL + "/Facility/GetProcessingFacilities",
    GET_FACILITY_CODE: API_URL + "/Facility/GetFacilityCode",
    GET_SUB_FACILITY_LIST: API_URL + "/SubFacility/GetSubFacilityList",
    SAVE_SUB_FACILITY: API_URL + "/SubFacility/SaveSubFacility",

    GET_SUB_FACILITY_TYPE_LIST: API_URL + "/SubFacility/GetSubFacilityType",
    SAVE_FACILITY_IMAGE: API_URL + "/Facility/SaveFacilityImage",
    SAVE_SUB_FACILITY_IMAGE: API_URL + "/SubFacility/SaveSubFacilityImage",
    EXPORT_TO_CSV: API_URL + "/Facility/ExportToXLS",
    EXPORT_TO_PDF: API_URL + "/Facility/ExportToPDF",
    EXPORT_QR_CODE: API_URL + "/Facility/GetFacilityQRCodeList",
    GET_FACILITY_MANAGER_LIST: API_URL + "/Facility/GetFacilityManagerList",
    GET_FACILITY_ACTIVITY: API_URL + "/Facility/GetFacilityAcitivity",
    UPDATE_FACILITY_ACTIVITY_LOG_STATUS: API_URL + "/Facility/UpdateFacilityAcitivityLogStatus",
    DELETE_FACILITY_ACTIVITY_LOG: API_URL + "/Facility/DeleteFacilityAcitivityLog"
  },
  ASSETS: {
    GET_ASSETS_LIST: API_URL + "/Asset/GetAssetList",
    GET_ASSET_NAME_BY_PARAM: API_URL + "/Asset/GetAssetNameByParam",
    SAVE_ASSETS: API_URL + "/Asset/SaveAsset",
    DELETE_ASSETS: API_URL + "/Asset/DeleteAsset",
    GET_ASSET_CODE: API_URL + "/Asset/GetAssetCode",
    GET_ASSET_CATEGORY: API_URL + "/Asset/GetAssetCategoryList",
    GET_ASSET_DEPARTMENT: API_URL + "/Department/GetDepartmentList",
    INSERT_UPDATE_DEPARTMENT: API_URL + "/Department/InsertUpdateDepartment",
    GET_ASSET_GROUPLIST: API_URL + "/Asset/GetAssetGroupList",
    GET_ASSET_SUBGROUPLIST: API_URL + "/Asset/GetAssetSubGroupList",
    GET_ASSET_TYPE_LIST: API_URL + "/Asset/GetAssetTypeList",
    GET_ASSET_CLASIFICATION_LIST: API_URL + "/Asset/GetAssetClassificationList",
    GET_ASSET_STATUS_LIST: API_URL + "/Asset/GetAssetStatusList",
    GET_VENDOR_LIST: API_URL + "/Vendor/ServiceProviderList",
    UPDATE_STATUS: API_URL + "/Asset/UpdateAssetStatus",
    NOTE_LIST: API_URL + "/Asset/GetAssetNotesList",
    NOTE_SAVE: API_URL + "/Asset/SaveAssetNotes",
    DELETE_NOTES: API_URL + "/Asset/DeleteAssetNotes",

    GET_ASSET_ATTACHMENT: API_URL + "/Asset/GetAssetAttachments",
    SAVE_ASSET_ATTACHMENT: API_URL + "/Asset/SaveAssetAttachment",
    SAVE_ASSET_IMAGE: API_URL + "/Asset/SaveAssetImage",
    DELETE_ASSET_ATTACHMENT: API_URL + "/Asset/DeleteAssetAttachment",
    EXPORT_TO_CSV: API_URL + "/Asset/ExportToXLS",
    EXPORT_TO_PDF: API_URL + "/Asset/ExportToPDF",
    EXPORT_QR_CODE: API_URL + "/Asset/GetAssetQRCodeList",
    GET_WARRANTY_LIST: API_URL + "/Asset/GetWarrantyList",
    SAVE_ASSET_WARRANTY_ATTACHMENT:
      API_URL + "/Asset/SaveAssetWarrantyAttachment",
    WARRANTY_EXPORT_TO_XLS: API_URL + "/Asset/WarrantyExportToXLS",
    GET_WARRANTY_ATTACHMENTS: API_URL + "/Asset/GetAssetWarrantyAttachments",
    SAVE_ASSET_WARRANTY: API_URL + "/Asset/SaveAssetWarranty",
    SAVE_ASSET_DETAILS: API_URL + "/Asset/SaveAssetDetails",
    GET_WARRANTY_TERM_LIST: API_URL + "/Asset/GetWarrantyTermList",
    MOVE_ASSET: API_URL + "/Asset/MoveAsset",
    GET_ASSET_DETAILS_LIST: API_URL + "/Asset/GetAssetDetailsList",


    GET_JOURNAL_ENTRY_BY_ASSET_ID: API_URL + "/Asset/GetJournalEntryByAssetID",
    GET_ASSET_STATUS_LOG: API_URL + "/Asset/GetLogByAssetID",
    DELETE_ASSET_DETAILS: API_URL + "/Asset/DeleteAssetDetails",
    GET_ASSET_MOVEMENT_LOG_LIST: API_URL + "/Asset/GetMovementLogByAssetID",
    EXPORT_ASSET_REPORT_CSV: API_URL + "/Asset/AllAssetExportToXLS",
    GET_ASSETS_REPORT_LIST: API_URL + "/Asset/GetAssetReport",
    CONVERT_TO_OWNED_ASSET: API_URL + "/Asset/ConvertToOwnedAsset",
    GET_WORKORDER_USED_SPARE_PARTS: API_URL + "/Asset/GetWorkOrderUsedSpareParts",
    GET_SPARE_PARTS_USAGE_REPORT: API_URL + "/Asset/GetSparePartsUsageReport",
    GET_MTTR_REPORT: API_URL + "/Asset/GetMttrReport",
    GET_MTTR_REPORT_FILTERS: API_URL + "/Asset/GetMttrReportFilters",
    GET_MTBF_REPORT: API_URL + "/Asset/GetMtbfReport",
    EXPORT_SPARE_PARTS_USAGE_REPORT_XLS: API_URL + "/Asset/SparePartsUsageReportExportToXLS",
    EXPORT_MTTR_REPORT_XLS: API_URL + "/Asset/MttrReportExportToXLS",
    EXPORT_MTBF_REPORT_XLS: API_URL + "/Asset/MtbfReportExportToXLS",
  },

  COMMON: {
    GET_CITY: API_URL + "/City/GetCity",
    GET_STATE: API_URL + "/State",
    GET_COUNTY: API_URL + "/County/Get",
    GET_TEAM: API_URL + "/Teams/GetTeam",
    GET_USER: API_URL + "/User/GetUser",

    GET_SERVICE_TECH: API_URL + "/ServiceTech/GetServiceTechList",
    GET_SERVICE_PROVIDER_LIST: API_URL + "/Vendor/ServiceProviderList",
    GET_TAXES: API_URL + "/TaxRate/GetTaxRateList",

  },

  SPEAR_PARTS: {
    GET_SPEAR_PARTS_LIST: API_URL + "/SpareParts/GetPartsList",
    SAVE_SPEAR_PARTS: API_URL + "/SpareParts/SaveSparePart",
    DELETE_SPEAR_PARTS: API_URL + "/SpareParts/DeletePart",
    GET_SPEAR_PARTS_CODE: API_URL + "/SpareParts/GetPartsCode",

    GET_PARTS_ATTACHMENTS: API_URL + "/SpareParts/GetPartsAttachments",
    SAVE_PARTS_ATTACHMENTS: API_URL + "/SpareParts/SavePartsAttachment",
    SAVE_PARTS_IMAGE: API_URL + "/SpareParts/SavePartsImage",
    DELETE_PARTS_ATTACHMENTS: API_URL + "/SpareParts/DeletePartsAttachment",

    EXPORT_TO_PDF: API_URL + "/SpareParts/ExportToPDF",
    EXPORT_TO_XLS: API_URL + "/SpareParts/ExportToXLS",
    EXPORT_QR_CODE: API_URL + "/SpareParts/GetPartsQRCodeList",

    GET_PARTS_STATUS: API_URL + "/SpareParts/GetPartsStatus",
    GET_PARTS_CATEGORY_LIST: API_URL + "/SpareParts/GetPartsCategory",
    GET_PARTS_UNIT_LIST: API_URL + "/SpareParts/GetPartsUOM",

    GET_PARTS_NOTES_LIST: API_URL + "/SpareParts/GetPartsNotesList",
    SAVE_PARTS_NOTES: API_URL + "/SpareParts/SavePartsNotes",

    LOCATION_WISE_STOCK:
      API_URL + "/StockAdjustment/GetAdjustmentListLocationWise",
    PURCHASE_HISTORY: API_URL + "/SpareParts/PurchaseHistory", // Pending
    STOCK_PICKING_HISTORY: API_URL + "/CycleCount/StockPicking",
    STOCK_CYCLE_COUNT_HISTORY: API_URL + "/CycleCount/GetCycleCountByPart", // Pending
    STOCK_ADJUSTMENT_HISTORY:
      API_URL + "/StockAdjustment/GetAdjustmentListByPart",
    SAVE_PARTS_VENDOR_MAP: API_URL + "/SpareParts/SavePartsVendorMap",
    DELETE_PARTS_VENDOR_MAP: API_URL + "/SpareParts/DeletePartsVendorMap",
    GET_CURRENT_STOCK_DETAILS: API_URL + "/SpareParts/GetCurrentStockDetails",
    GET_PERSONAL_STOCK_REPORT: API_URL + "/SpareParts/GetPersonalStockReport",
    EXPORT_REPORT_TO_XLS: API_URL + "/SpareParts/ExportReportToXLS"
  },

  STOCK_ADJUSTMENT: {
    LIST: API_URL + "/StockAdjustment/GetAdjustmentList",
    SAVE: API_URL + "/StockAdjustment/SaveAdjustment",
    DELETE: API_URL + "/StockAdjustment/DeleteAdjustment",
    EXPORT_TO_PDF: API_URL + "/ ",
    EXPORT_TO_XLS: API_URL + "/StockAdjustment/ExportToXLS",
    EXPORT_QR_CODE: API_URL + "/ ",
    GET_ID: API_URL + "/StockAdjustment/GetStockAdjustmentCode",
    GET_BY_ID: API_URL + "/StockAdjustment/GetStockAdjustmentByID",
    MOVE_STOCK: API_URL + "/StockAdjustment/MoveStock",
    GET_STOCK_TRANSACTION_REPORT: API_URL + "/StockAdjustment/GetStockTransactionList",
    EXPORT_STOCK_TRANSACTION_REPORT_XLS: API_URL + "/StockAdjustment/StockTransactionReportExportToXLS",
    GET_STOCK_ADJUSTMENT_REPORT: API_URL + "/StockAdjustment/GetStockAdjustmentReport",
    EXPORT_STOCK_ADJUSTMENT_REPORT_XLS: API_URL + "/StockAdjustment/StockAdjustmentReportExportToXLS",
    EXPORT_STOCK_ADJUSTMENT_REPORT_PDF: API_URL + "/StockAdjustment/StockAdjustmentReportExportToPDF",
  },

  CYCLE_COUNT: {
    GET_BY_ID: API_URL + "/CycleCount/GetCycleCountByID",
    GET_BY_PART_NAME: API_URL + "/CycleCount/GetCycleCountByPart",
    LIST: API_URL + "/CycleCount/GetCycleCountList",
    SAVE: API_URL + "/CycleCount/SaveInventoryCycleCount",
    DELETE: API_URL + "/CycleCount/DeleteInventoryCycleCount",
    EXPORT_TO_PDF: API_URL + "/CycleCount/ExportToPDF",
    EXPORT_TO_XLS: API_URL + "/CycleCount/ExportToXLS",
    EXPORT_QR_CODE: API_URL + "/ ",
    GET_ID: API_URL + "/CycleCount/GetCycleCountCode",
    GET_STOCK_PICKING: API_URL + "/CycleCount/GetStockPicking",
    ADD_STOCK_PICKING: API_URL + "/CycleCount/InsertStockPicking",
    STOCK_COUNT: API_URL + "/StockCount/GetCurrentStock",
    GET_STOCK_COUNT_PICKING: API_URL + "/StockCount/GetStockPickingList",
    GET_STOCK_PICKING_DETAILS: API_URL + "/StockCount/GetStockPickingDetails",
    GET_STOCK_PICKING_BY_PART: API_URL + "/StockCount/GetStockPickingByPart",
    EXPORT_PICKING_TO_PDF: API_URL + "/StockCount/ExportPickingToPDF",
    EXPORT_PICKING_TO_XLS: API_URL + "/StockCount/ExportPickingToXLS",
    SAVE_STOCK_RETURN: API_URL + "/StockReturn/SaveStockReturn"
  },
  DEPRECIATION: {
    METHODS: API_URL + "/Depreciation/GetDepreciationMethodList",
    APPORTIONS: API_URL + "/Depreciation/GetDepreciationApportionList",
    LIST: API_URL + "/Depreciation/GetDepreciationList",
    SAVE: API_URL + "/Depreciation/SaveDepreciation",
    DELETE: API_URL + "/Depreciation/DeleteDepreciation",
    GET_USEFUL_LIST: API_URL + "/Depreciation/GetUsefulLifeList",

    GET_CONVENTION_PERCENTAGE_LIST:
      API_URL + "/Depreciation/GetConventionPercentageList",
    GET_CONVENTION_TYPE_LIST:
      API_URL + "/Depreciation/GetDepreciationConventionTypeList",
    GET_GAAP: API_URL + "/Asset/GetGAAPDepreciation",
    GET_REVALUATION_LIST: API_URL + "/Depreciation/GetRevaluationList",
    GET_DISPOSAL_LIST: API_URL + "/Depreciation/GetDisposalList",
    GET_MCARS_DEPRECIATION: API_URL + "/Asset/GetMCARSDepreciation",
    SAVE_ASSET_DEPRECIATION: API_URL + "/Asset/SaveAssetDepreciation",
    VALIDATE_MARS_TRANSACTION: API_URL + "/Asset/ValidateMCARSTransaction",
    GET_ASSET_BOOK_VALUE: API_URL + "/Asset/GetAssetBookValue",
    SAVE_REVALUATION: API_URL + "/Depreciation/SaveRevaluation",
    SAVE_REVALUATION_ATTACHMENT:
      API_URL + "/Depreciation/SaveRevaluationAttachment",
    GET_DISPOSAL_TYPE_LIST: API_URL + "/Depreciation/GetDisposalTypeList",
    SAVE_DISPOSAL: API_URL + "/Depreciation/SaveDisposal",
    SAVE_DISPOSAL_ATTACHMENT: API_URL + "/Depreciation/SaveDisposalAttachment",
    GET_CURRET_USERFUL_LIFE: API_URL + "/Depreciation/GetCurrentUsefullife",
    GET_ASSET_DEPRECIATION_LIST: API_URL + "/Asset/GetAssetDepreciationList",
    ALL_ASSET_DEPRECIATION_EXPORT_TO_XLS: API_URL + "/Asset/AllAssetDepreciationExportToXLS",
    GET_DEPRECIATION_REPORT: API_URL + "/Depreciation/GetDepreciationReportList",
    DEPRECIATION_REPORT_EXPORT_TO_XLS: API_URL + "/Depreciation/DepreciationReportExportToXLS",
    GET_AUDITOR_REPORT: API_URL + "/Depreciation/GetAuditorReportList",
    AUDITOR_REPORT_EXPORT_TO_XLS: API_URL + "/Depreciation/AuditorReportExportToXLS",

  },
  PURCHASE_ORDER: {
    GET_CODE: API_URL + "/PurchaseOrder/GetPurchaseOrderCode",
    GET_STATUSES: API_URL + "/PurchaseOrder/GetPurchaseOrderStatusList",
    GET_ORDER_TYPES: API_URL + "/PurchaseOrder/GetPurchaseOrderTypeList",
    SAVE: API_URL + "/PurchaseOrder/SavePurchaseOrder",
    SAVE_ORDER_FILE: API_URL + "/PurchaseOrder/SavePurchaseOrderFile",
    DELETE: API_URL + "/PurchaseOrder/DeletePurchaseOrder",
    DELETE_ORDER_FILE: API_URL + "/PurchaseOrder/DeletePurchaseOrderAttachment",
    LIST: API_URL + "/PurchaseOrder/GetPurchaseOrderList",
    GET_ORDER_BY_ID: API_URL + "/PurchaseOrder/GetPurchaseOrderByID",
    GET_FILES: API_URL + "/PurchaseOrder/GetPurchaseOrderAttachments",
    EXPORT_PDF: API_URL + "/PurchaseOrder/ExportToPDF",
    EXPORT_XLS: API_URL + "/PurchaseOrder/ExportToXLS",
    PROCESS: API_URL + "/PurchaseOrder/ProcessPurchaseOrder",
    Save_Purchase_Order_From_PR: API_URL + "/PurchaseOrder/SavePurchaseOrderFromPR",
  },
  PURCHASE_REQUEST: {
    GET_CODE: API_URL + "/PurchaseRequest/GetPurchaseRequestCode",
    GET_STATUSES: API_URL + "/PurchaseRequest/GetPurchaseRequestStatusList",
    GET_REQUEST_TYPES: API_URL + "/PurchaseRequest/GetPurchaseRequestTypeList",
    SAVE: API_URL + "/PurchaseRequest/SavePurchaseRequest",
    SAVE_REQUEST_FILE: API_URL + "/PurchaseRequest/SavePurchaseRequestFile",
    DELETE: API_URL + "/PurchaseRequest/DeletePurchaseRequest",
    DELETE_REQUEST_FILE: API_URL + "/PurchaseRequest/DeletePurchaseRequestAttachment",
    LIST: API_URL + "/PurchaseRequest/GetPurchaseRequestList",
    GET_REQUEST_BY_ID: API_URL + "/PurchaseRequest/GetPurchaseRequestByID",
    GET_FILES: API_URL + "/PurchaseRequest/GetPurchaseRequestAttachments",
    EXPORT_PDF: API_URL + "/PurchaseRequest/ExportToPDF",
    EXPORT_XLS: API_URL + "/PurchaseRequest/ExportToXLS",
    PROCESS: API_URL + "/PurchaseRequest/ProcessPurchaseRequest",
  },
  WORK_REQUEST: {
    GET_WORK_REQUEST_LIST: API_URL + "/WorkRequest/GetWorkRequestList",
    GET_STATUS_LIST: API_URL + "/WorkRequest/GetStatusList",
    GET_PRIORITY_LIST: API_URL + "/WorkRequest/GetPriorityList",
    GET_CODE: API_URL + "/WorkRequest/GetCode",
    MOVE_STATUS: API_URL + "/WorkRequest/MoveStatus",
    SAVE_WORK_REQUEST: API_URL + "/WorkRequest/SaveWorkRequest",
    UPLOAD_IMAGE: API_URL + "/WorkRequest/UploadImage",
    UPLOAD_ATTACHMENT: API_URL + "/WorkRequest/UploadAttachment",
    GET_WORK_REQUEST_BY_ID: API_URL + "/WorkRequest/GetWorkRequestByID",
    GET_ATTACHMENT: API_URL + "/WorkRequest/GetWorkRequestAttachments",
    GET_IMAGES: API_URL + "/WorkRequest/GetWorkRequestImages",
    DELETE_WORK_REQUEST_FILES: API_URL + "/WorkRequest/DeleteWorkRequestFiles",

    SAVE_WORK_REQUEST_NOTES: API_URL + "/WorkRequest/SaveWorkRequestNotes",
    DELETE_WORK_REQUEST_NOTES: API_URL + "/WorkRequest/DeleteWorkRequestNotes",

    GET_WORK_REQUEST_NOTES_LIST:
      API_URL + "/WorkRequest/GetWorkRequestNotesList",
    EXPORT_PDF: API_URL + "/WorkRequest/ExportToPDF",
    EXPORT_XLS: API_URL + "/WorkRequest/ExportToXLS",
    DELETE_WORK_REQUEST: API_URL + "/WorkRequest/DeleteWorkRequest",
    GET_LIST_FOR_KANBAN_VIEW: API_URL + "/WorkRequest/GetListForKanbanView", // New action for Kanban view
    WORK_REQUEST_PROCESS_AUDIO: API_URL + "/Integration/ProcessAudio",
    WORK_REQUEST_PROCESS_FEEDBACK: API_URL + "/Integration/ProcessFeeback"
  },

  WORK_ORDER: {
    GET_WORK_STATUS_LIST: API_URL + "/WorkOrder/GetWOStatusList",
    GET_WORK_PRIORITY_LIST: API_URL + "/WorkOrder/GetWOPriorityList",
    GET_WORK_MAINTENANCE_LIST: API_URL + "/WorkOrder/GetWOMaintenanceTypeList",
    GET_WORK_ASSIGNMENT_TYPE_LIST:
      API_URL + "/WorkOrder/GetWOAssignmentTypeList",
    GET_WORK_CODE: API_URL + "/WorkOrder/GetWOCode",
    GET_WORK_ORDER_LIST: API_URL + "/WorkOrder/GetWorkOrderList",
    MOVE_STATUS: API_URL + "/WorkOrder/MoveStatus",
    GET_WORK_ORDER_BY_ID: API_URL + "/WorkOrder/GetWorkOrderByID",
    EXPORT_TO_PDF: API_URL + "/WorkOrder/ExportToPDF",
    EXPORT_TO_XLS: API_URL + "/WorkOrder/ExportToXLS",
    DELETE_WORK_ORDER: API_URL + "/WorkOrder/DeleteWorkOrder",

    GET_WORK_ATTACHMENT: API_URL + "/WorkOrder/GetWorkOrderAttachments",
    GET_WORK_IMAGES: API_URL + "/WorkOrder/GetWorkOrderImages",
    DELETE_WORK_ORDER_FILES: API_URL + "/WorkOrder/DeleteWorkOrderFiles",

    UPLOAD_IMAGE: API_URL + "/WorkOrder/UploadImage",
    UPLOAD_ATTACHMENT: API_URL + "/WorkOrder/UploadAttachment",
    SAVE_WORK_ORDER: API_URL + "/WorkOrder/SaveWorkOrder",
    SAVE_WORK_ORDER_TASK_DETAILS:
      API_URL + "/WorkOrder/SaveWorkOrderCheckLists",
    GET_WORK_ORDER_NOTE_LIST: API_URL + "/WorkOrder/GetWorkOrderNotesList",
    SAVE_WORK_ORDER_NOTE_SAVE: API_URL + "/WorkOrder/SaveWorkOrderNotes",
    DELETE_WORK_ORDER_NOTE: API_URL + "/WorkOrder/DeleteWorkOrderNotes",
    GET_WORK_ORDER_TASK: API_URL + "/WorkOrder/GetWOTasks",
    GET_WORK_ORDER_COMPLETION_BY_ID:
      API_URL + "/WorkOrder/GetWorkOrderCompletionByID",
    GET_WORK_ORDER_COMPLETION_ATTACHMENTS:
      API_URL + "/WorkOrder/GetWorkOrderCompletionAttachments",
    SAVE_WORK_ORDER_COMPLETION: API_URL + "/WorkOrder/SaveWorkOrderCompletion",
    SAVE_WORK_ORDER_COMPLETION_ATTACHMENT:
      API_URL + "/WorkOrder/UploadWorkOrderCompletionAttachment",

    UPDATE_WORK_ORDER_INPROGRESS:
      API_URL + "/WorkOrder/UpdateWorkOrderInprogress",
    UPDATE_WORK_ORDER_SCHEDULE: API_URL + "/WorkOrder/UpdateWorkOrderSchedule",
    SAVE_WORK_ORDER_ASSETS: API_URL + "/WorkOrder/SaveWorkOrderAssets",
    SAVE_WORK_ORDER_INVENTORY: API_URL + "/WorkOrder/SaveWorkOrderInventory",
    WORK_ORDER_STOCK_PICKING: API_URL + "/StockCount/InsertStockPicking",

    SAVE_WORK_ORDER_ACTIVITY: API_URL + "/WorkOrder/SaveWorkOrderTasks",
    GET_WORK_ORDER_COMPLETION_LOG: API_URL + "/WorkOrder/GetWorkOrderCompletionLog",
    GET_WORK_ORDER_TASK_LOG: API_URL + "/WorkOrder/GetWorkOrderTaskLog",
    WO_TASK_LOG_EXPORT_TO_PDF: API_URL + "/WorkOrder/WOTaskLogExportToPDF",
    WO_TASK_LOG_EXPORT_TO_XLS: API_URL + "/WorkOrder/WOTaskLogExportToXLS",
    GET_WORK_ORDER_KANBAN_VIEW: API_URL + "/WorkOrder/GetWorkOrderKanbanView",
    RESCHEDULE_WORK_ORDER: API_URL + "/WorkOrder/RescheduleWorkOrder",
    WORK_ORDER_SAVE_TASK_ATTACHMENTS: API_URL + "/WorkOrder/SaveWOTaskAttachments",
    WORK_ORDER_GET_PARTS_BY_WO_ID: API_URL + "/WorkOrder/GetPartsByWOID",
    CHECK_WO_TASKS_COMPLETION: API_URL + "/WorkOrder/CheckWOTasksCompletion"
  },

  CHECKLIST: {
    GET_CHECKLIST_TYPES: API_URL + "/CheckList/GetChecklistTypeList",
    GET_CHECKLIST_CODE: API_URL + "/CheckList/GetCheckListCode",
    GET_CHECKLISTS: API_URL + "/CheckList/GetChecklistList",
    GET_CHECKLIST_BY_ID: API_URL + "/CheckList/GetChecklistTasks",

    SAVE_CHECKLIST: API_URL + "/CheckList/SaveCheckList",
    DELETE_CHECKLIST: API_URL + "/CheckList/DeleteCheckList",
    GET_CHECKLIST_INPUT_TYPES: API_URL + "/CheckList/GetInputTypeList",
    SAVE_CHECKLIST_TASK: API_URL + "/CheckList/SaveCheckListTasks",
    SAVE_CHECKLIST_TASKS_ASSET_MAPPING:
      API_URL + "/CheckList/SaveCheckListAssetMapping",
    GET_ASSETS_BY_CHECKLIST: API_URL + "/CheckList/GetCheckListAssets",
    DUPLICATE_CHECKLIST: API_URL + "/CheckList/DuplicateCheckList",
  },

  SAGE: {
    TEST_CONNECTION: API_URL + "/Sage/TestConnection",
    SAVE_CONNECTION: API_URL + "/Sage/SaveSageConfig",

    SYNC_ACCOUNT_GROUPS: API_URL + "/Sage/ImportSageGLGroup",
    SYNC_ACCOUNT: API_URL + "/Sage/ImportSageGL",
    SYNC_FINANCIAL_BOOK: API_URL + "/Sage/ImportSageFinancialBook",
    SYNC_ITEM_GL: API_URL + "/Sage/ImportItemGL",
    SYNC_LOCATION: API_URL + "/Sage/ImportLocation",
    SYNC_DEPARTMENT: API_URL + "/Sage/ImportDepartment",
    SYNC_VENDOR: API_URL + "/Sage/ImportSageVendor",

    GET_SYNC_ACCOUNT_GROUPS: API_URL + "/Sage/GetAccountGroupList",
    GET_SYNC_ACCOUNT: API_URL + "/Sage/GetAccountList",
    GET_SYNC_FINANCIAL_BOOK: API_URL + "/Sage/GetFinancialBookList",
    GET_SYNC_ITEM_GL: API_URL + "/Sage/GetItemGLList",
    GET_SAGE_FACILITY_LIST: API_URL + "/Sage/GetSageFacilityList",
    GET_SAGE_DEPARTMENT_LIST: API_URL + "/Sage/GetSageDepartmentList",

    GET_ASSET_SUB_GROUP_CODE: API_URL + "/Asset/GetAssetSubGroupCode",
    GET_ASSET_SUB_GROUP_LIST: API_URL + "/Asset/GetAssetSubGroupList",
    SAVE_ASSET_SUB_GROUP: API_URL + "/Asset/SaveAssetSubGroup",
    DELETE_ASSET_GROUP: API_URL + "/Asset/DeleteAssetSubGroup",

    GET_ASSET_MAPPING_LIST:
      API_URL + "/Sage/GetSageAssetGroupAccountMappingList",
    SAVE_ASSET_MAPPING: API_URL + "/Sage/SaveSageAssetGroupAccountMapping",

    GET_ASSET_INVENTORY_MAPPING_LIST:
      API_URL + "/Sage/GetSageInventoryGroupAccountMappingList",
    SAVE_ASSET_INVENTORY_MAPPING:
      API_URL + "/Sage/SaveSageInventoryGroupAccountMapping",

    GET_ASSET_OTHER_MAPPING_LIST: API_URL + "/Sage/GetAssetAccountMapping",
    SAVE_ASSET_OTHER_MAPPING: API_URL + "/Sage/SaveSageAssetAccountMapping",
    SAVE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING: API_URL + "/Sage/SaveSageAssetGroupExpenseAccountMapping",

    POST_ASSET_DISPOSAL_TO_SAGE: API_URL + "/Sage/PostToSageAssetDisposal",
    POST_ASSET_REVALUATION_TO_SAGE: API_URL + "/Sage/PostToSageAssetRevaluation",
    POST_ASSET_DEPRECIATION_TO_SAGE: API_URL + "/Sage/PostToSageAssetDepreciation",

    GET_REF_NUMBER_LIST: API_URL + "/Sage/GetRefNumberList",
    GET_DEFAULT_DATA_SYNC: API_URL + "/Sage/GetSyncDataList",
    GET_SAGE_CONFIG: API_URL + "/Sage/GetSageAccountDetails",
    GET_SAGE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING_LIST: API_URL + "/Sage/GetSageAssetGroupExpenseAccountMappingList",
    GET_USED_ACCUMULATED_DEPRECIATION_ACCOUNT_LIST: API_URL + "/Sage/GetUsedAccmDeprAccountList",
    GET_USED_ACCOUNT_LIST: API_URL + "/Sage/GetUsedAccountList",
    POST_ALL: API_URL + "/Sage/BulkPostToSageAssetDepreciation",
    POST_ALL_STATUS: API_URL + "/Sage/BulkDepreciationStatus",
  },
  BILL_COM: {
    TEST_CONNECTION: API_URL + "/BillCom/TestConnection",
    SAVE_CONNECTION: API_URL + "/BillCom/SaveBillComConfig",
    GET_BILL_COM_CONFIG: API_URL + "/BillCom/GetBillComAccountDetails",
    SYNC_VENDOR: API_URL + "/BillCom/ImportBillComVendor",
    SYNC_DEPARTMENT: API_URL + "/BillCom/ImportBillComDepartments",
    GET_BILL_COM_VENDORS: API_URL + "/BillCom/GetBillComVendors",
    GET_BILL_COM_DEPARTMENTS: API_URL + "/BillCom/GetBillComDepartments",
  },
  MAINTENANCE_CALENDER: {
    GET_FREQUENCY_LIST: API_URL + "/Scheduler/GetFrequencyList",
    GET_SCHEDULER_CODE: API_URL + "/Scheduler/GetSchedulerCode",
    GET_SCHEDULER_TYPE: API_URL + "/Scheduler/GetSchedulerType",
    SAVE_SCHEDULER: API_URL + "/Scheduler/SaveScheduler",
    GET_SCHEDULER_LIST: API_URL + "/Scheduler/GetSchedulerList",
    GET_SCHEDULER_BY_ID: API_URL + "/Scheduler/GetSchedulerByID",
    DELETE_SCHEDULER: API_URL + "/Scheduler/DeleteScheduler",
    UPLOAD_IMAGE: API_URL + "/Scheduler/UploadImage",
    UPLOAD_ATTACHMENT: API_URL + "/Scheduler/UploadAttachment",
    GET_SCHEDULER_ATTACHMENTS: API_URL + "/Scheduler/GetSchedulerAttachments",
    GET_SCHEDULER_IMAGES: API_URL + "/Scheduler/GetSchedulerImages",
    DELETE_SCHEDULER_FILES: API_URL + "/Scheduler/DeleteSchedulerFiles",
    EXPORT_TO_PDF: API_URL + "/Scheduler/ExportToPDF",
    EXPORT_TO_XLS: API_URL + "/Scheduler/ExportToXLS",
  },
  RECEIPT: {
    GET_RECEIPT_CODE: API_URL + "/Recipt/GetReciptCode",
    SAVE_PURCHASE_RECEIPT: API_URL + "/Recipt/SavePurchaseRecipt",
    UPLOAD_ATTACHMENT: API_URL + "/Recipt/UploadAttachment",
    GET_RECEIPT_LIST: API_URL + "/Recipt/GetReciptList",
    EXPORT_TO_PDF: API_URL + "/Receipt/ExportToPDF",
    EXPORT_TO_XLS: API_URL + "/Receipt/ExportToXLS",
    GET_RECEIPT_BY_ID: API_URL + "/Recipt/GetReciptByID",
    GET_RECEIPT_ATTACHMENTS: API_URL + "/Recipt/GetReceiptAttachments",
    GET_PURCHASE_HISTORY_LIST: API_URL + "/PurchaseHistory/GetPurchaseHistoryList",
  },
  VENDORS: {
    FILTERED_SERVICE_PROVIDER_LIST: API_URL + "/Vendor/FilteredServiceProviderList",
    REDUX_FILTERED_SERVICE_PROVIDER_LIST: API_URL + "/Vendor/FilteredServiceProviderList",
    SAVE_VENDOR_DETAILS: API_URL + "/Vendor/SaveVendor",
    GET_VENDOR_LIST: API_URL + "/Vendor/List",
    SAVE_VENDOR_FILES: API_URL + "/Vendor/SaveVendorFile",
    GET_VENDOR_BY_ID: API_URL + "/Vendor/GetByID",
    DELETE_VENDOR: API_URL + "/Vendor/DeleteVendor",
    GET_SERVICE_TYPE: API_URL + "/ServiceType/GetServiceType",
    EXPORT_TO_CSV: API_URL + "/Vendor/ExportVendorsExcel",
    EXPORT_TO_PDF: API_URL + "/Vendor/ExportVendorsPDF",
    GET_VENDOR_ATTACHMENT: API_URL + "/Vendor/GetVendorAttachment",
    GET_VENDOR_CODE: API_URL + "/Vendor/GetVendorCode",
  },
  DASHBOARD: {
    GET_ADOPTION_DASHBOARD_COUNTS: API_URL + "/Dashboard/GetAdoptionDashboardCounts",
    EXPORT_ADOPTION_COUNTS_PDF: API_URL + "/Dashboard/ExportAdoptionCountsToPDF",
    EXPORT_ADOPTION_COUNTS_XLS: API_URL + "/Dashboard/ExportAdoptionCountsToXLS",
    EXPORT_KPI_TOTAL_WRS_PDF: API_URL + "/Dashboard/ExportKpiTotalWorkRequestsToPDF",
    EXPORT_KPI_TOTAL_WRS_XLS: API_URL + "/Dashboard/ExportKpiTotalWorkRequestsToXLS",
    EXPORT_KPI_AVG_TASKS_PDF: API_URL + "/Dashboard/ExportKpiAvgTasksPerUserToPDF",
    EXPORT_KPI_AVG_TASKS_XLS: API_URL + "/Dashboard/ExportKpiAvgTasksPerUserToXLS",
    GET_COMPLETED_WOS_WITHOUT_ROOT_CAUSE: API_URL + "/Dashboard/GetCompletedWOsWithoutRootCause",
    EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_PDF: API_URL + "/Dashboard/ExportCompletedWOsWithoutRootCauseToPDF",
    EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_XLS: API_URL + "/Dashboard/ExportCompletedWOsWithoutRootCauseToXLS",
    EXPORT_KPI_AVG_HOURS_PDF: API_URL + "/Dashboard/ExportKpiAvgHoursPerTaskToPDF",
    EXPORT_KPI_AVG_HOURS_XLS: API_URL + "/Dashboard/ExportKpiAvgHoursPerTaskToXLS",
    EXPORT_KPI_CHECKLIST_TASKS_PDF: API_URL + "/Dashboard/ExportKpiChecklistTasksToPDF",
    EXPORT_KPI_CHECKLIST_TASKS_XLS: API_URL + "/Dashboard/ExportKpiChecklistTasksToXLS",
    EXPORT_KPI_CHECKLIST_COMPLETION_PDF: API_URL + "/Dashboard/ExportKpiChecklistCompletionToPDF",
    EXPORT_KPI_CHECKLIST_COMPLETION_XLS: API_URL + "/Dashboard/ExportKpiChecklistCompletionToXLS",
    GET_WORK_REQUEST_ORIGINS: API_URL + "/Dashboard/GetWorkRequestOrigins",
    GET_TASK_ORIGINS_GALLUS: API_URL + "/Dashboard/GetTaskOriginsGallus",
    GET_GROWER_TASK_ORIGINS: API_URL + "/Dashboard/GetGrowerTaskOrigins",
    GET_WR_STATUS_PIE_CHART: API_URL + "/Dashboard/GetWRStatusPieChart",
    EXPORT_WR_STATUS_PIE_CHART_PDF: API_URL + "/Dashboard/ExportWRStatusPieChartToPDF",
    EXPORT_WR_STATUS_PIE_CHART_XLS: API_URL + "/Dashboard/ExportWRStatusPieChartToXLS",
    GET_USER_ACTIVITY_SUMMARY: API_URL + "/Dashboard/GetUserActivitySummary",
    GET_WR_COMPLETENESS_BY_FACILITY: API_URL + "/Dashboard/GetWRCompletenessByFacility",
    GET_STOCK_ADJUSTMENT_CHART: API_URL + "/Dashboard/GetStockAdjustmentChart",
    GET_INVENTORY_MOVEMENT_CHART: API_URL + "/Dashboard/GetInventoryMovementChart",
    GET_CHECKLIST_BY_CREATOR: API_URL + "/Dashboard/GetChecklistByCreator",
    EXPORT_CHECKLIST_BY_CREATOR_PDF: API_URL + "/Dashboard/ExportChecklistByCreatorToPDF",
    EXPORT_CHECKLIST_BY_CREATOR_XLS: API_URL + "/Dashboard/ExportChecklistByCreatorToXLS",
    GET_MANAGER_DASHBOARD_WR_KPIS: API_URL + "/Dashboard/GetManagerDashboardWRKPIs",
    GET_MANAGER_DASHBOARD_WR: API_URL + "/Dashboard/GetManagerDashboardWorkRequests",
    GET_MANAGER_DASHBOARD_TEAM: API_URL + "/Dashboard/GetManagerDashboardTeamMetrics",
    GET_MANAGER_DASHBOARD_PURCHASING: API_URL + "/Dashboard/GetManagerDashboardPurchasing",
    GET_MANAGER_DASHBOARD_ASSETS: API_URL + "/Dashboard/GetManagerDashboardAssetMetrics",
    GET_RELIABILITY_MATRIX_DATA: API_URL + "/Dashboard/GetReliabilityMatrixData",
    GET_CLOSED_TASKS_REPORT: API_URL + "/Dashboard/GetClosedTasksReport",
    GET_ASSETS_UPTIME_REPORT: API_URL + "/Dashboard/GetAssetsUptimeReport",
    GET_ASSETS_TIME_COST_REPORT: API_URL + "/Dashboard/GetAssetsTimeCostReport",
    GET_WARRANTIES_REPORT: API_URL + "/Dashboard/GetWarrantiesReport",
    GET_LOW_STOCK_REPORT: API_URL + "/Dashboard/GetLowStockReport",
    EXPORT_CLOSED_TASKS_REPORT_XLS: API_URL + "/Dashboard/ClosedTasksReportExportToXLS",
    EXPORT_ASSETS_UPTIME_REPORT_XLS: API_URL + "/Dashboard/AssetsUptimeReportExportToXLS",
    EXPORT_ASSETS_TIME_COST_REPORT_XLS: API_URL + "/Dashboard/AssetsTimeCostReportExportToXLS",
    EXPORT_WARRANTIES_REPORT_XLS: API_URL + "/Dashboard/WarrantiesReportExportToXLS",
    EXPORT_LOW_STOCK_REPORT_XLS: API_URL + "/Dashboard/LowStockReportExportToXLS",
    EXPORT_WORK_REQUEST_ORIGINS_PDF: API_URL + "/Dashboard/ExportWorkRequestOriginsToPDF",
    EXPORT_WORK_REQUEST_ORIGINS_XLS: API_URL + "/Dashboard/ExportWorkRequestOriginsToXLS",
    EXPORT_GROWER_TASK_ORIGINS_PDF: API_URL + "/Dashboard/ExportGrowerTaskOriginsToPDF",
    EXPORT_GROWER_TASK_ORIGINS_XLS: API_URL + "/Dashboard/ExportGrowerTaskOriginsToXLS",
    EXPORT_USER_ACTIVITY_SUMMARY_PDF: API_URL + "/Dashboard/ExportUserActivitySummaryToPDF",
    EXPORT_USER_ACTIVITY_SUMMARY_XLS: API_URL + "/Dashboard/ExportUserActivitySummaryToXLS",
    EXPORT_WR_COMPLETENESS_BY_FACILITY_PDF: API_URL + "/Dashboard/ExportWRCompletenessByFacilityToPDF",
    EXPORT_WR_COMPLETENESS_BY_FACILITY_XLS: API_URL + "/Dashboard/ExportWRCompletenessByFacilityToXLS",
    EXPORT_STOCK_ADJUSTMENT_PDF: API_URL + "/Dashboard/ExportStockAdjustmentChartToPDF",
    EXPORT_STOCK_ADJUSTMENT_XLS: API_URL + "/Dashboard/ExportStockAdjustmentChartToXLS",
    EXPORT_INVENTORY_MOVEMENT_PDF: API_URL + "/Dashboard/ExportInventoryMovementChartToPDF",
    EXPORT_INVENTORY_MOVEMENT_XLS: API_URL + "/Dashboard/ExportInventoryMovementChartToXLS",
    EXPORT_MANAGER_WORK_REQUESTS_PDF: API_URL + "/Dashboard/ExportManagerWorkRequestsToPDF",
    EXPORT_MANAGER_WORK_REQUESTS_XLS: API_URL + "/Dashboard/ExportManagerWorkRequestsToXLS",
    EXPORT_MANAGER_PURCHASING_PDF: API_URL + "/Dashboard/ExportManagerPurchasingToPDF",
    EXPORT_MANAGER_PURCHASING_XLS: API_URL + "/Dashboard/ExportManagerPurchasingToXLS",
    EXPORT_TASK_ORIGINS_GALLUS_PDF: API_URL + "/Dashboard/ExportTaskOriginsGallusToPDF",
    EXPORT_TASK_ORIGINS_GALLUS_XLS: API_URL + "/Dashboard/ExportTaskOriginsGallusToXLS",
    GET_MY_DASHBOARD_WR_OVER_TIME: API_URL + "/Dashboard/GetMyDashboardWROverTime",
    GET_MY_DASHBOARD_WR_BY_FACILITY_OVER_TIME: API_URL + "/Dashboard/GetMyDashboardWRByFacilityOverTime",
    EXPORT_MY_DASHBOARD_WR_BY_FACILITY_OT_PDF: API_URL + "/Dashboard/ExportMyDashboardWRByFacilityOTToPDF",
    EXPORT_MY_DASHBOARD_WR_BY_FACILITY_OT_XLS: API_URL + "/Dashboard/ExportMyDashboardWRByFacilityOTToXLS",
    GET_MY_DASHBOARD_TASKS_BY_FACILITY_OVER_TIME: API_URL + "/Dashboard/GetMyDashboardTasksByFacilityOverTime",
    EXPORT_MY_DASHBOARD_TASKS_BY_FACILITY_OT_PDF: API_URL + "/Dashboard/ExportMyDashboardTasksByFacilityOTToPDF",
    EXPORT_MY_DASHBOARD_TASKS_BY_FACILITY_OT_XLS: API_URL + "/Dashboard/ExportMyDashboardTasksByFacilityOTToXLS",
    GET_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM: API_URL + "/Dashboard/GetMyDashboardWRCompletenessByFarm",
    EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM_PDF: API_URL + "/Dashboard/ExportMyDashboardWRCompletenessByFarmToPDF",
    EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM_XLS: API_URL + "/Dashboard/ExportMyDashboardWRCompletenessByFarmToXLS",
    GET_MY_DASHBOARD_WR_COMPLETENESS_BY_ME: API_URL + "/Dashboard/GetMyDashboardWRCompletenessByMe",
    EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_ME_PDF: API_URL + "/Dashboard/ExportMyDashboardWRCompletenessByMeToPDF",
    EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_ME_XLS: API_URL + "/Dashboard/ExportMyDashboardWRCompletenessByMeToXLS",
    GET_MY_DASHBOARD_TASKS_OVER_TIME: API_URL + "/Dashboard/GetMyDashboardTasksOverTime",
    GET_MY_DASHBOARD_RESPONSIVENESS_BY_FARM: API_URL + "/Dashboard/GetMyDashboardResponsivenessByFarm",
    GET_MY_DASHBOARD_RESPONSIVENESS_INDIVIDUAL: API_URL + "/Dashboard/GetMyDashboardResponsivenessIndividual",
    GET_MY_DASHBOARD_WALKTHROUGHS_BY_FARM: API_URL + "/Dashboard/GetMyDashboardWalkthroughsByFarm",
    GET_MY_DASHBOARD_WALKTHROUGHS_OVER_TIME: API_URL + "/Dashboard/GetMyDashboardWalkthroughsOverTime",
    GET_MANAGER_HOURS_BY_FACILITY: API_URL + "/Dashboard/GetManagerHoursByFacility",
    EXPORT_MY_DASHBOARD_TO_XLS: API_URL + "/Dashboard/ExportMyDashboardToXLS",
    EXPORT_MY_DASHBOARD_TO_PDF: API_URL + "/Dashboard/ExportMyDashboardToPDF",
    EXPORT_MY_DASHBOARD_WR_OVER_TIME_PDF: API_URL + "/Dashboard/ExportMyDashboardWROverTimeToPDF",
    EXPORT_MY_DASHBOARD_WR_OVER_TIME_XLS: API_URL + "/Dashboard/ExportMyDashboardWROverTimeToXLS",
    EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_PDF: API_URL + "/Dashboard/ExportMyDashboardTasksOverTimeToPDF",
    EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_XLS: API_URL + "/Dashboard/ExportMyDashboardTasksOverTimeToXLS",
    EXPORT_MY_DASHBOARD_RESP_BY_FARM_PDF: API_URL + "/Dashboard/ExportMyDashboardRespByFarmToPDF",
    EXPORT_MY_DASHBOARD_RESP_BY_FARM_XLS: API_URL + "/Dashboard/ExportMyDashboardRespByFarmToXLS",
    EXPORT_MY_DASHBOARD_RESP_IND_PDF: API_URL + "/Dashboard/ExportMyDashboardRespIndToPDF",
    EXPORT_MY_DASHBOARD_RESP_IND_XLS: API_URL + "/Dashboard/ExportMyDashboardRespIndToXLS",
    EXPORT_MY_DASHBOARD_WALK_BY_FARM_PDF: API_URL + "/Dashboard/ExportMyDashboardWalkByFarmToPDF",
    EXPORT_MY_DASHBOARD_WALK_BY_FARM_XLS: API_URL + "/Dashboard/ExportMyDashboardWalkByFarmToXLS",
    EXPORT_MY_DASHBOARD_WALK_OVER_TIME_PDF: API_URL + "/Dashboard/ExportMyDashboardWalkOverTimeToPDF",
    EXPORT_MY_DASHBOARD_WALK_OVER_TIME_XLS: API_URL + "/Dashboard/ExportMyDashboardWalkOverTimeToXLS",
    EXPORT_MY_DASHBOARD_PM_BY_FARM_PDF: API_URL + "/Dashboard/ExportMyDashboardPMByFarmToPDF",
    EXPORT_MY_DASHBOARD_PM_BY_FARM_XLS: API_URL + "/Dashboard/ExportMyDashboardPMByFarmToXLS",
    EXPORT_MY_DASHBOARD_PM_OVER_TIME_PDF: API_URL + "/Dashboard/ExportMyDashboardPMOverTimeToPDF",
    EXPORT_MY_DASHBOARD_PM_OVER_TIME_XLS: API_URL + "/Dashboard/ExportMyDashboardPMOverTimeToXLS",
    EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_PDF: API_URL + "/Dashboard/ExportMyDashboardReactiveByFarmToPDF",
    EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_XLS: API_URL + "/Dashboard/ExportMyDashboardReactiveByFarmToXLS",
    EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_PDF: API_URL + "/Dashboard/ExportMyDashboardReactiveOverTimeToPDF",
    EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_XLS: API_URL + "/Dashboard/ExportMyDashboardReactiveOverTimeToXLS",
    GET_MY_DASHBOARD_PM_BY_FARM: API_URL + "/Dashboard/GetMyDashboardPMByFarm",
    GET_MY_DASHBOARD_PM_OVER_TIME: API_URL + "/Dashboard/GetMyDashboardPMOverTime",
    GET_MY_DASHBOARD_REACTIVE_BY_FARM: API_URL + "/Dashboard/GetMyDashboardReactiveByFarm",
    GET_MY_DASHBOARD_REACTIVE_OVER_TIME: API_URL + "/Dashboard/GetMyDashboardReactiveOverTime",
    EXPORT_MANAGER_HOURS_BY_FACILITY_PDF: API_URL + "/Dashboard/ExportManagerHoursByFacilityToPDF",
    EXPORT_MANAGER_HOURS_BY_FACILITY_XLS: API_URL + "/Dashboard/ExportManagerHoursByFacilityToXLS",
    GET_MANAGER_HOURS_BY_FACILITY_LP: API_URL + "/Dashboard/GetManagerHoursByFacilityLP",
    EXPORT_MANAGER_HOURS_BY_FACILITY_LP_PDF: API_URL + "/Dashboard/ExportManagerHoursByFacilityLPToPDF",
    EXPORT_MANAGER_HOURS_BY_FACILITY_LP_XLS: API_URL + "/Dashboard/ExportManagerHoursByFacilityLPToXLS",
    GET_MANAGER_HOURS_BY_FACILITY_RM: API_URL + "/Dashboard/GetManagerHoursByFacilityRM",
    EXPORT_MANAGER_HOURS_BY_FACILITY_RM_PDF: API_URL + "/Dashboard/ExportManagerHoursByFacilityRMToPDF",
    EXPORT_MANAGER_HOURS_BY_FACILITY_RM_XLS: API_URL + "/Dashboard/ExportManagerHoursByFacilityRMToXLS",
    EXPORT_TASKS_AGING_PRIORITY_PDF: API_URL + "/Dashboard/ExportTasksAgingWithPriorityToPDF",
    EXPORT_TASKS_AGING_PRIORITY_XLS: API_URL + "/Dashboard/ExportTasksAgingWithPriorityToXLS",
    EXPORT_WR_BY_PRIORITY_PDF: API_URL + "/Dashboard/ExportWorkRequestsByPriorityToPDF",
    EXPORT_WR_BY_PRIORITY_XLS: API_URL + "/Dashboard/ExportWorkRequestsByPriorityToXLS",
    EXPORT_TASK_FUNNEL_PDF: API_URL + "/Dashboard/ExportTaskFunnelToPDF",
    EXPORT_TASK_FUNNEL_XLS: API_URL + "/Dashboard/ExportTaskFunnelToXLS",
    EXPORT_HIGH_PRI_WRS_PDF: API_URL + "/Dashboard/ExportHighPriorityWorkRequestsToPDF",
    EXPORT_HIGH_PRI_WRS_XLS: API_URL + "/Dashboard/ExportHighPriorityWorkRequestsToXLS",
    EXPORT_TASK_CREATION_TIME_PDF: API_URL + "/Dashboard/ExportTaskCreationTimeToPDF",
    EXPORT_TASK_CREATION_TIME_XLS: API_URL + "/Dashboard/ExportTaskCreationTimeToXLS",
    EXPORT_TASK_COMPLETION_TIME_PDF: API_URL + "/Dashboard/ExportTaskCompletionTimeToPDF",
    EXPORT_TASK_COMPLETION_TIME_XLS: API_URL + "/Dashboard/ExportTaskCompletionTimeToXLS",
    EXPORT_COMPLETED_TASKS_PDF: API_URL + "/Dashboard/ExportCompletedTasksByEmployeeToPDF",
    EXPORT_COMPLETED_TASKS_XLS: API_URL + "/Dashboard/ExportCompletedTasksByEmployeeToXLS",
    GET_COMPLETED_TASKS_BY_FARM: API_URL + "/Dashboard/GetCompletedTasksByFarm",
    EXPORT_COMPLETED_TASKS_BY_FARM_PDF: API_URL + "/Dashboard/ExportCompletedTasksByFarmToPDF",
    EXPORT_COMPLETED_TASKS_BY_FARM_XLS: API_URL + "/Dashboard/ExportCompletedTasksByFarmToXLS",
    GET_COMPLETED_TASKS_BY_RM: API_URL + "/Dashboard/GetCompletedTasksByRM",
    EXPORT_COMPLETED_TASKS_BY_RM_PDF: API_URL + "/Dashboard/ExportCompletedTasksByRMToPDF",
    EXPORT_COMPLETED_TASKS_BY_RM_XLS: API_URL + "/Dashboard/ExportCompletedTasksByRMToXLS",
    GET_COMPLETED_TASKS_BY_LP: API_URL + "/Dashboard/GetCompletedTasksByLP",
    EXPORT_COMPLETED_TASKS_BY_LP_PDF: API_URL + "/Dashboard/ExportCompletedTasksByLPToPDF",
    EXPORT_COMPLETED_TASKS_BY_LP_XLS: API_URL + "/Dashboard/ExportCompletedTasksByLPToXLS",
    GET_COMPLETED_TASKS_BY_GROWER: API_URL + "/Dashboard/GetCompletedTasksByGrower",
    EXPORT_COMPLETED_TASKS_BY_GROWER_PDF: API_URL + "/Dashboard/ExportCompletedTasksByGrowerToPDF",
    EXPORT_COMPLETED_TASKS_BY_GROWER_XLS: API_URL + "/Dashboard/ExportCompletedTasksByGrowerToXLS",
    GET_LOGGED_HOURS_BY_RM: API_URL + "/Dashboard/GetLoggedHoursByRM",
    EXPORT_LOGGED_HOURS_BY_RM_PDF: API_URL + "/Dashboard/ExportLoggedHoursByRMToPDF",
    EXPORT_LOGGED_HOURS_BY_RM_XLS: API_URL + "/Dashboard/ExportLoggedHoursByRMToXLS",
    GET_LOGGED_HOURS_BY_LP: API_URL + "/Dashboard/GetLoggedHoursByLP",
    EXPORT_LOGGED_HOURS_BY_LP_PDF: API_URL + "/Dashboard/ExportLoggedHoursByLPToPDF",
    EXPORT_LOGGED_HOURS_BY_LP_XLS: API_URL + "/Dashboard/ExportLoggedHoursByLPToXLS",
    GET_LOGGED_HOURS_BY_GROWER: API_URL + "/Dashboard/GetLoggedHoursByGrower",
    EXPORT_LOGGED_HOURS_BY_GROWER_PDF: API_URL + "/Dashboard/ExportLoggedHoursByGrowerToPDF",
    EXPORT_LOGGED_HOURS_BY_GROWER_XLS: API_URL + "/Dashboard/ExportLoggedHoursByGrowerToXLS",
    EXPORT_LOGGED_HOURS_PDF: API_URL + "/Dashboard/ExportLoggedHoursByEmployeeToPDF",
    EXPORT_LOGGED_HOURS_XLS: API_URL + "/Dashboard/ExportLoggedHoursByEmployeeToXLS",
    EXPORT_PM_REACTIVE_PDF: API_URL + "/Dashboard/ExportPMReactiveToPDF",
    EXPORT_PM_REACTIVE_XLS: API_URL + "/Dashboard/ExportPMReactiveToXLS",
    GET_PURCHASING_METHOD_BY_WO: API_URL + "/Dashboard/GetPurchasingMethodByWO",
    EXPORT_PURCHASING_METHOD_COUNT_PDF: API_URL + "/Dashboard/ExportPurchasingMethodCountToPDF",
    EXPORT_PURCHASING_METHOD_COUNT_XLS: API_URL + "/Dashboard/ExportPurchasingMethodCountToXLS",
    EXPORT_PURCHASING_METHOD_VALUE_PDF: API_URL + "/Dashboard/ExportPurchasingMethodValueToPDF",
    EXPORT_PURCHASING_METHOD_VALUE_XLS: API_URL + "/Dashboard/ExportPurchasingMethodValueToXLS",
    EXPORT_PURCHASING_METHOD_PDF: API_URL + "/Dashboard/ExportPurchasingMethodToPDF",
    EXPORT_PURCHASING_METHOD_XLS: API_URL + "/Dashboard/ExportPurchasingMethodToXLS",
    EXPORT_PURCHASING_SPEND_PDF: API_URL + "/Dashboard/ExportPurchasingSpendToPDF",
    EXPORT_PURCHASING_SPEND_XLS: API_URL + "/Dashboard/ExportPurchasingSpendToXLS",
    EXPORT_GOODS_ON_ORDER_PDF: API_URL + "/Dashboard/ExportGoodsOnOrderToPDF",
    EXPORT_GOODS_ON_ORDER_XLS: API_URL + "/Dashboard/ExportGoodsOnOrderToXLS",
    EXPORT_PURCHASE_RECEIPTS_PDF: API_URL + "/Dashboard/ExportPurchaseReceiptsToPDF",
    EXPORT_PURCHASE_RECEIPTS_XLS: API_URL + "/Dashboard/ExportPurchaseReceiptsToXLS",
    EXPORT_LOW_INVENTORY_PDF: API_URL + "/Dashboard/ExportLowInventoryToPDF",
    EXPORT_LOW_INVENTORY_XLS: API_URL + "/Dashboard/ExportLowInventoryToXLS",
    EXPORT_DOWN_ASSETS_PDF: API_URL + "/Dashboard/ExportDownAssetsToPDF",
    EXPORT_DOWN_ASSETS_XLS: API_URL + "/Dashboard/ExportDownAssetsToXLS",
    EXPORT_ASSET_DOWNTIME_PDF: API_URL + "/Dashboard/ExportAssetDowntimeToPDF",
    EXPORT_ASSET_DOWNTIME_XLS: API_URL + "/Dashboard/ExportAssetDowntimeToXLS",
    EXPORT_MTTR_MTBF_PDF: API_URL + "/Dashboard/ExportMttrMtbfToPDF",
    EXPORT_MTTR_MTBF_XLS: API_URL + "/Dashboard/ExportMttrMtbfToXLS",
    EXPORT_RELIABILITY_MATRIX_PDF: API_URL + "/Dashboard/ExportReliabilityMatrixToPDF",
    EXPORT_RELIABILITY_MATRIX_XLS: API_URL + "/Dashboard/ExportReliabilityMatrixToXLS",
    EXPORT_EXPIRING_WARRANTIES_PDF: API_URL + "/Dashboard/ExportExpiringWarrantiesToPDF",
    EXPORT_EXPIRING_WARRANTIES_XLS: API_URL + "/Dashboard/ExportExpiringWarrantiesToXLS",
    GET_WRS_WITHOUT_TASK_BY_PRIORITY: API_URL + "/Dashboard/GetWRsWithoutTaskByPriority",
    EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_PDF: API_URL + "/Dashboard/ExportManagerKpiWRsWithoutTaskToPDF",
    EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_XLS: API_URL + "/Dashboard/ExportManagerKpiWRsWithoutTaskToXLS",
    EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_PDF: API_URL + "/Dashboard/ExportManagerKpiTasksWithoutAssignmentToPDF",
    EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_XLS: API_URL + "/Dashboard/ExportManagerKpiTasksWithoutAssignmentToXLS",
    EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_PDF: API_URL + "/Dashboard/ExportManagerKpiTasksWithoutScheduleToPDF",
    EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_XLS: API_URL + "/Dashboard/ExportManagerKpiTasksWithoutScheduleToXLS",
    EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_PDF: API_URL + "/Dashboard/ExportManagerKpiTasksNotCompletedToPDF",
    EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_XLS: API_URL + "/Dashboard/ExportManagerKpiTasksNotCompletedToXLS",
    EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_PDF: API_URL + "/Dashboard/ExportWRsWithoutTaskByPriorityToPDF",
    EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_XLS: API_URL + "/Dashboard/ExportWRsWithoutTaskByPriorityToXLS",
    GET_SCHEDULED_TASKS_BY_FACILITY: API_URL + "/Dashboard/GetScheduledTasksByFacility",
    EXPORT_SCHEDULED_TASKS_DETAIL_PDF: API_URL + "/Dashboard/ExportScheduledTasksDetailToPDF",
    EXPORT_SCHEDULED_TASKS_DETAIL_XLS: API_URL + "/Dashboard/ExportScheduledTasksDetailToXLS",
    GET_TASKS_AND_WRS_BY_FACILITY: API_URL + "/Dashboard/GetTasksAndWRsByFacility",
    EXPORT_TASKS_AND_WRS_BY_PRIORITY_PDF: API_URL + "/Dashboard/ExportTasksAndWRsByPriorityToPDF",
    EXPORT_TASKS_AND_WRS_BY_PRIORITY_XLS: API_URL + "/Dashboard/ExportTasksAndWRsByPriorityToXLS",
    GET_TOTAL_RESPONSE_TIME: API_URL + "/Dashboard/GetTotalResponseTime",
    EXPORT_TOTAL_RESPONSE_TIME_PDF: API_URL + "/Dashboard/ExportTotalResponseTimeToPDF",
    EXPORT_TOTAL_RESPONSE_TIME_XLS: API_URL + "/Dashboard/ExportTotalResponseTimeToXLS",
  }
};

export const ACTIONS = {
  RESET_REDUCER: "ACTIONS/RESET_REDUCER",
  DIALOG: "ACTIONS/DIALOG",
  LOADER: {
    FP_STATUS: "ACTIONS/LOADER/FP_STATUS",
    MENU_COLLAPSE: "ACTIONS/LOADER/MENU_COLLAPSE",
  },
  MASTER: {
    STATES: "ACTIONS/MASTER/STATES",
    COUNTY: "ACTIONS/MASTER/COUNTY",
    CITY: "ACTIONS/MASTER/CITY",
    MANAGERS: "ACTIONS/MASTER/MANAGERS",
    SERVICE_TECHS: "ACTIONS/MASTER/SERVICE_TECHS",
    TEAMS: "ACTIONS/MASTER/TEAMS",
    ELECTRICITY_PROVIDERS: "ACTIONS/MASTER/ELECTRICITY_PROVIDERS",
    GAS_PROVIDERS: "ACTIONS/MASTER/GAS_PROVIDERS",
    WATER_PROVIDERS: "ACTIONS/MASTER/WATER_PROVIDERS",
    TELEPHONE_PROVIDERS: "ACTIONS/MASTER/TELEPHONE_PROVIDERS",
    ASSETS_CATEGORIES: "ACTIONS/MASTER/ASSETS_CATEGORIES",
    ASSETS_DEPARTMENTS: "ACTIONS/MASTER/ASSETS_DEPARTMENTS",
    ASSETS_GROUPS: "ACTIONS/MASTER/ASSETS_GROUPS",
    ASSETS_SUB_GROUPS: "ACTIONS/MASTER/ASSETS_SUB_GROUPS",
    ASSETS_TYPES: "ACTIONS/MASTER/ASSETS_TYPES",
    ASSETS_CLASSIFICATIONS: "ACTIONS/MASTER/ASSETS_CLASSIFICATIONS",
    ASSETS_STATUES: "ACTIONS/MASTER/ASSETS_STATUES",
    DEPRECIATION_METHODS: "ACTIONS/MASTER/DEPRECIATION_METHODS",
    DEPRECIATION_APPORTIONS: "ACTIONS/MASTER/DEPRECIATION_APPORTIONS",
  },

  USER: {
    LOGIN: "ACTIONS/USER/LOGIN",
    USER: "ACTIONS/USER/USER",
    LOGOUT: "ACTIONS/USER/LOGOUT",
    FORGET_PASSWORD: "ACTIONS/USER/FORGET_PASSWORD",
    RESET_PASSWORD: "ACTIONS/USER/RESET_PASSWORD",
    PASSWORD_RESET: "ACTIONS/USER/PASSWORD_RESET",
  },
};

export const SAGA_ACTIONS = {
  USER: {
    LOGIN: "SAGA_ACTIONS/USER/LOGIN",
    LOGIN_WITH_PERMISSION: "SAGA_ACTIONS/USER/LOGIN_WITH_PERMISSION",
    LOGOUT: "SAGA_ACTIONS/USER/LOGOUT",
    FORGET_PASSWORD: "SAGA_ACTIONS/USER/FORGET_PASSWORD",
    RESET_PASSWORD: "SAGA_ACTIONS/USER/RESET_PASSWORD",
    REGISTER: "SAGA_ACTIONS/USER/REGISTER",
    GET_DESIGNS: "SAGA_ACTIONS/USER/GET_DESIGNS",
    SAVE_DESIGN: "SAGA_ACTIONS/USER/SAVE_DESIGN",
    UPDATE_DESIGN: "SAGA_ACTIONS/USER/UPDATE_DESIGN",
    IMAGE_LIST: "SAGA_ACTIONS/USER/IMAGE_LIST",
    IMAGE_UPLOAD: "SAGA_ACTIONS/USER/IMAGE_UPLOAD",
    IMAGE_DELETE: "SAGA_ACTIONS/USER/IMAGE_DELETE",
    SAVE_TEAM_USER_MAPPING: "SAGA_ACTIONS/USER/SAVE_TEAM_USER_MAPPING",
    SAVE_USER_MODULE_BUNDLE: "SAGA_ACTIONS/USER/SAVE_USER_MODULE_BUNDLE",
    SAVE_USER_MODULE: "SAGA_ACTIONS/USER/SAVE_USER_MODULE",
    DELETE_USER_MODULE: "SAGA_ACTIONS/USER/DELETE_USER_MODULE",
    LoginWithPermissions: "SAGA_ACTIONS/USER/LoginWithPermissions",
    GET_ALL_API_ENDPOINTS: "SAGA_ACTIONS/USER/GET_ALL_API_ENDPOINTS",
    DELETE_USER: "SAGA_ACTIONS/USER/DELETE_USER",

    GET_USER_TYPE_BY_ID: "SAGA_ACTIONS/USER/GET_USER_TYPE_BY_ID",
    GET_USER_TYPES: "SAGA_ACTIONS/USER/GET_USER_TYPES",
    GET_USER_MODULES: "SAGA_ACTIONS/USER/GET_USER_MODULES",
    GET_USER_MODULE_BY_ID: "SAGA_ACTIONS/USER/GET_USER_MODULE_BY_ID",
    SAVE_USER_TYPE: "SAGA_ACTIONS/USER/SAVE_USER_TYPE",
    DELETE_USER_TYPE: "SAGA_ACTIONS/USER/DELETE_USER_TYPE",
    SAVE_USER: "SAGA_ACTIONS/USER/SAVE_USER",
    GET_USER: "SAGA_ACTIONS/USER/GET_USER",
    SAVE_USER_MODULE_API_ENTITY: "SAGA_ACTIONS/USER/SAVE_USER_MODULE_API_ENTITY",

  },
  FACILITY: {
    GET_FACILITY_LIST: "ACTIONS/FACILITY/GET_FACILITY_LIST",
    GET_FACILITY_DETAILS: "ACTIONS/FACILITY/GET_FACILITY_DETAILS",
    SAVE_FACILITY: "ACTIONS/FACILITY/SAVE_FACILITY",
    SAVE_FACILITY_MASTER: "ACTIONS/FACILITY/SAVE_FACILITY_MASTER",
    SAVE_TEAM: "ACTIONS/FACILITY/SAVE_TEAM",
    SAVE_DEPARTMENT: "ACTIONS/FACILITY/SAVE_DEPARTMENT",
    SAVE_SERVICE_TECH_MASTER: "ACTIONS/FACILITY/SAVE_SERVICE_TECH_MASTER",
    DELETE_FACILITY: "ACTIONS/FACILITY/DELETE_FACILITY",
    DELETE_FACILITY_MANAGER: "ACTIONS/FACILITY/DELETE_FACILITY_MANAGER",
    DELETE_SERVICE_TECH: "ACTIONS/FACILITY/DELETE_SERVICE_TECH",
    DELETE_TEAM: "ACTIONS/FACILITY/DELETE_TEAM",
    GET_PROCESSING_FACILITY_LIST:
      "ACTIONS/FACILITY/GET_PROCESSING_FACILITY_LIST",
    GET_FACILITY_CODE: "ACTIONS/FACILITY/GET_FACILITY_CODE",
    GET_SUB_FACILITY_LIST: "ACTIONS/FACILITY/GET_SUB_FACILITY_LIST",
    SAVE_SUB_FACILITY: "ACTIONS/FACILITY/SAVE_SUB_FACILITY",
    GET_SUB_FACILITY_TYPE_LIST: "ACTIONS/FACILITY/GET_SUB_FACILITY_TYPE_LIST",
    SAVE_FACILITY_IMAGE: "ACTIONS/FACILITY/SAVE_FACILITY_IMAGE",
    SAVE_SUB_FACILITY_IMAGE: "ACTIONS/FACILITY/SAVE_SUB_FACILITY_IMAGE",
    EXPORT_TO_CSV: "ACTIONS/FACILITY/EXPORT_TO_CSV",
    EXPORT_TO_PDF: "ACTIONS/FACILITY/EXPORT_TO_PDF",
    EXPORT_QR_CODE: "ACTIONS/FACILITY/EXPORT_QR_CODE",
    GET_FACILITY_MANAGER_LIST: "ACTIONS/FACILITY/GET_FACILITY_MANAGER_LIST",
    GET_FACILITY_ACTIVITY: "ACTIONS/FACILITY/GET_FACILITY_ACTIVITY",
    UPDATE_FACILITY_ACTIVITY_LOG_STATUS: "ACTIONS/FACILITY/UPDATE_FACILITY_ACTIVITY_LOG_STATUS",
    DELETE_FACILITY_ACTIVITY_LOG: "ACTIONS/FACILITY/DELETE_FACILITY_ACTIVITY_LOG",
  },

  ASSETS: {
    GET_ASSETS_LIST: "ACTIONS/ASSETS/GET_ASSETS_LIST",
    GET_ASSET_NAME_BY_PARAM: "ACTIONS/ASSETS/GET_ASSET_NAME_BY_PARAM",
    SAVE_ASSETS: "ACTIONS/ASSETS/SAVE_ASSETS",
    DELETE_ASSETS: "ACTIONS/ASSETS/DELETE_ASSETS",
    GET_ASSET_CODE: "ACTIONS/ASSETS/GET_ASSET_CODE",
    GET_ASSET_CATEGORY: "ACTIONS/ASSETS/GET_ASSET_CATEGORY",
    GET_ASSET_DEPARTMENT: "ACTIONS/ASSETS/GET_ASSET_DEPARTMENT",
    GET_ASSET_GROUPLIST: "ACTIONS/ASSETS/GET_ASSET_GROUPLIST",
    GET_ASSET_SUBGROUPLIST: "ACTIONS/ASSETS/GET_ASSET_SUBGROUPLIST",
    GET_ASSET_TYPE_LIST: "ACTIONS/ASSETS/GET_ASSET_TYPE_LIST",
    GET_ASSET_CLASIFICATION_LIST: "ACTIONS/ASSETS/GET_ASSET_CLASIFICATION_LIST",
    GET_ASSET_STATUS_LIST: "ACTIONS/ASSETS/GET_ASSET_STATUS_LIST",
    GET_VENDOR_LIST: "ACTIONS/ASSETS/GET_VENDOR_LIST",
    UPDATE_STATUS: "ACTIONS/ASSETS/UPDATE_STATUS",
    NOTE_LIST: "ACTIONS/ASSETS/NOTE_LIST",
    NOTE_SAVE: "ACTIONS/ASSETS/NOTE_SAVE",
    DELETE_NOTES: "ACTIONS/ASSETS/DELETE_NOTES",
    SAVE_ASSET_IMAGE: "ACTIONS/ASSETS/SAVE_ASSET_IMAGE",

    GET_ASSET_ATTACHMENT: "ACTIONS/ASSETS/GET_ASSET_ATTACHMENT",
    SAVE_ASSET_ATTACHMENT: "ACTIONS/ASSETS/SAVE_ASSET_ATTACHMENT",
    DELETE_ASSET_ATTACHMENT: "ACTIONS/ASSETS/DELETE_ASSET_ATTACHMENT",
    EXPORT_TO_CSV: "ACTIONS/ASSETS/EXPORT_TO_CSV",
    EXPORT_TO_PDF: "ACTIONS/ASSETS/EXPORT_TO_PDF",
    EXPORT_QR_CODE: "ACTIONS/ASSETS/EXPORT_QR_CODE",
    GET_WARRANTY_LIST: "ACTIONS/ASSETS/GET_WARRANTY_LIST",
    SAVE_ASSET_WARRANTY_ATTACHMENT:
      "ACTIONS/ASSETS/SAVE_ASSET_WARRANTY_ATTACHMENT",
    WARRANTY_EXPORT_TO_XLS: "ACTIONS/ASSETS/WARRANTY_EXPORT_TO_XLS",
    GET_WARRANTY_ATTACHMENTS: "ACTIONS/ASSETS/GET_WARRANTY_ATTACHMENTS",
    SAVE_ASSET_WARRANTY: "ACTIONS/ASSETS/SAVE_ASSET_WARRANTY",
    SAVE_ASSET_DETAILS: "ACTIONS/ASSETS/SAVE_ASSET_DETAILS",
    GET_WARRANTY_TERM_LIST: "ACTIONS/ASSETS/GET_WARRANTY_TERM_LIST",
    MOVE_ASSET: "ACTIONS/ASSETS/MOVE_ASSET",
    GET_ASSET_DETAILS_LIST: "ACTIONS/ASSETS/GET_ASSET_DETAILS_LIST",
    GET_JOURNAL_ENTRY_BY_ASSET_ID: "ACTIONS/ASSETS/GET_JOURNAL_ENTRY_BY_ASSET_ID",
    EXPORT_QR_CODEPNG: "ACTIONS/ASSETS/EXPORT_QR_CODEPNG",
    GET_ASSET_STATUS_LOG: "ACTIONS/ASSETS/GET_ASSET_STATUS_LOG",
    DELETE_ASSET_DETAILS: "ACTIONS/ASSETS/DELETE_ASSET_DETAILS",
    GET_ASSET_MOVEMENT_LOG_LIST: "ACTIONS/ASSETS/GET_ASSET_MOVEMENT_LOG_LIST",
    EXPORT_ASSET_REPORT_CSV: "ACTIONS/ASSETS/EXPORT_ASSET_REPORT_CSV",
    GET_ASSETS_REPORT_LIST: "ACTIONS/ASSETS/GET_ASSETS_REPORT_LIST",
    CONVERT_TO_OWNED_ASSET: "ACTIONS/ASSETS/CONVERT_TO_OWNED_ASSET",
    GET_WORKORDER_USED_SPARE_PARTS: "ACTIONS/ASSETS/GET_WORKORDER_USED_SPARE_PARTS",
    GET_SPARE_PARTS_USAGE_REPORT: "ACTIONS/ASSETS/GET_SPARE_PARTS_USAGE_REPORT",
    GET_MTTR_REPORT: "ACTIONS/ASSETS/GET_MTTR_REPORT",
    GET_MTTR_REPORT_FILTERS: "ACTIONS/ASSETS/GET_MTTR_REPORT_FILTERS",
    GET_MTBF_REPORT: "ACTIONS/ASSETS/GET_MTBF_REPORT",
    EXPORT_SPARE_PARTS_USAGE_REPORT_XLS: "ACTIONS/ASSETS/EXPORT_SPARE_PARTS_USAGE_REPORT_XLS",
    EXPORT_MTTR_REPORT_XLS: "ACTIONS/ASSETS/EXPORT_MTTR_REPORT_XLS",
    EXPORT_MTBF_REPORT_XLS: "ACTIONS/ASSETS/EXPORT_MTBF_REPORT_XLS",
  },

  COMMON: {
    GET_CITY: "ACTIONS/COMMON/GET_CITY",
    GET_STATE: "ACTIONS/COMMON/GET_STATE",
    GET_COUNTY: "ACTIONS/COMMON/GET_COUNTY",
    GET_TEAM: "ACTIONS/COMMON/GET_TEAM",
    DELETE_TEAM: "ACTIONS/COMMON/DELETE_TEAM",
    GET_USER: "ACTIONS/COMMON/GET_USER",

    GET_SERVICE_TECH: "ACTIONS/COMMON/GET_SERVICE_TECH",
    GET_SERVICE_PROVIDER_LIST: "ACTIONS/COMMON/GET_SERVICE_PROVIDER_LIST",
    GET_TAXES: "ACTIONS/COMMON/GET_TAXES",
  },

  SPEAR_PARTS: {
    GET_SPEAR_PARTS_LIST: "ACTIONS/SPEAR_PARTS/GET_SPEAR_PARTS_LIST",
    SAVE_SPEAR_PARTS: "ACTIONS/SPEAR_PARTS/SAVE_SPEAR_PARTS",
    DELETE_SPEAR_PARTS: "ACTIONS/SPEAR_PARTS/DELETE_SPEAR_PARTS",
    GET_PARTS_ATTACHMENTS: "ACTIONS/SPEAR_PARTS/GET_PARTS_ATTACHMENTS",
    SAVE_PARTS_ATTACHMENTS: "ACTIONS/SPEAR_PARTS/SAVE_PARTS_ATTACHMENTS",
    DELETE_PARTS_ATTACHMENTS: "ACTIONS/SPEAR_PARTS/DELETE_PARTS_ATTACHMENTS",
    GET_SPEAR_PARTS_CODE: "ACTIONS/SPEAR_PARTS/GET_SPEAR_PARTS_CODE",

    SAVE_PARTS_IMAGE: "ACTIONS/SPEAR_PARTS/SAVE_PARTS_IMAGE",
    GET_PARTS_STATUS: "ACTIONS/SPEAR_PARTS/GET_PARTS_STATUS",
    GET_PARTS_CATEGORY_LIST: "ACTIONS/SPEAR_PARTS/GET_PARTS_CATEGORY_LIST",
    GET_PARTS_UNIT_LIST: "ACTIONS/SPEAR_PARTS/GET_PARTS_UNIT_LIST",

    EXPORT_TO_PDF: "ACTIONS/SPEAR_PARTS/EXPORT_TO_PDF",
    EXPORT_TO_XLS: "ACTIONS/SPEAR_PARTS/EXPORT_TO_XLS",
    EXPORT_QR_CODE: "ACTIONS/SPEAR_PARTS/EXPORT_QR_CODE",

    GET_PARTS_NOTES_LIST: "ACTIONS/SPEAR_PARTS/GET_PARTS_NOTES_LIST",
    SAVE_PARTS_NOTES: "ACTIONS/SPEAR_PARTS/SAVE_PARTS_NOTES",

    LOCATION_WISE_STOCK: "ACTIONS/SPEAR_PARTS/LOCATION_WISE_STOCK",
    PURCHASE_HISTORY: "ACTIONS/SPEAR_PARTS/PURCHASE_HISTORY",
    STOCK_PICKING_HISTORY: "ACTIONS/SPEAR_PARTS/STOCK_PICKING_HISTORY",
    STOCK_CYCLE_COUNT_HISTORY: "ACTIONS/SPEAR_PARTS/STOCK_CYCLE_COUNT_HISTORY",
    STOCK_ADJUSTMENT_HISTORY: "ACTIONS/SPEAR_PARTS/STOCK_ADJUSTMENT_HISTORY",
    SAVE_PARTS_VENDOR_MAP: "ACTIONS/SPEAR_PARTS/SAVE_PARTS_VENDOR_MAP",
    DELETE_PARTS_VENDOR_MAP: "ACTIONS/SPEAR_PARTS/DELETE_PARTS_VENDOR_MAP",
    GET_CURRENT_STOCK_DETAILS: "ACTIONS/SPEAR_PARTS/GET_CURRENT_STOCK_DETAILS",
    GET_PERSONAL_STOCK_REPORT: "ACTIONS/SPEAR_PARTS/GET_PERSONAL_STOCK_REPORT",
    EXPORT_REPORT_TO_XLS: "ACTIONS/SPEAR_PARTS/EXPORT_REPORT_TO_XLS",
  },

  STOCK_ADJUSTMENT: {
    LIST: "ACTIONS/STOCK_ADJUSTMENT/LIST",
    SAVE: "ACTIONS/STOCK_ADJUSTMENT/SAVE",
    DELETE: "ACTIONS/STOCK_ADJUSTMENT/DELETE",
    EXPORT_TO_PDF: "ACTIONS/STOCK_ADJUSTMENT/EXPORT_TO_PDF",
    EXPORT_TO_XLS: "ACTIONS/STOCK_ADJUSTMENT/EXPORT_TO_XLS",
    EXPORT_QR_CODE: "ACTIONS/STOCK_ADJUSTMENT/EXPORT_QR_CODE",
    GET_ID: "ACTIONS/STOCK_ADJUSTMENT/GET_ID",
    GET_BY_ID: "ACTIONS/STOCK_ADJUSTMENT/GET_BY_ID",
    MOVE_STOCK: "ACTIONS/STOCK_ADJUSTMENT/MOVE_STOCK",
    GET_STOCK_TRANSACTION_REPORT: "ACTIONS/STOCK_ADJUSTMENT/GET_STOCK_TRANSACTION_REPORT",
    EXPORT_STOCK_TRANSACTION_REPORT_XLS: "ACTIONS/STOCK_ADJUSTMENT/EXPORT_STOCK_TRANSACTION_REPORT_XLS",
    GET_STOCK_ADJUSTMENT_REPORT: "ACTIONS/STOCK_ADJUSTMENT/GET_STOCK_ADJUSTMENT_REPORT",
    EXPORT_STOCK_ADJUSTMENT_REPORT_XLS: "ACTIONS/STOCK_ADJUSTMENT/EXPORT_STOCK_ADJUSTMENT_REPORT_XLS",
    EXPORT_STOCK_ADJUSTMENT_REPORT_PDF: "ACTIONS/STOCK_ADJUSTMENT/EXPORT_STOCK_ADJUSTMENT_REPORT_PDF",
  },

  CYCLE_COUNT: {
    GET_BY_ID: "ACTIONS/CYCLE_COUNT/GET_BY_ID",
    GET_BY_PART_NAME: "ACTIONS/CYCLE_COUNT/GET_BY_PART_NAME",
    LIST: "ACTIONS/CYCLE_COUNT/LIST",
    SAVE: "ACTIONS/CYCLE_COUNT/SAVE",
    DELETE: "ACTIONS/CYCLE_COUNT/DELETE",
    EXPORT_TO_PDF: "ACTIONS/CYCLE_COUNT/EXPORT_TO_PDF",
    EXPORT_TO_XLS: "ACTIONS/CYCLE_COUNT/EXPORT_TO_XLS",
    EXPORT_QR_CODE: "ACTIONS/CYCLE_COUNT/EXPORT_QR_CODE",
    GET_ID: "ACTIONS/CYCLE_COUNT/GET_ID",
    GET_STOCK_PICKING: "ACTIONS/CYCLE_COUNT/GET_STOCK_PICKING",
    ADD_STOCK_PICKING: "ACTIONS/CYCLE_COUNT/ADD_STOCK_PICKING",
    STOCK_COUNT: "ACTIONS/CYCLE_COUNT/STOCK_COUNT",

    GET_STOCK_COUNT_PICKING: "ACTIONS/CYCLE_COUNT/GET_STOCK_COUNT_PICKING",
    GET_STOCK_PICKING_DETAILS: "ACTIONS/CYCLE_COUNT/GET_STOCK_PICKING_DETAILS",
    GET_STOCK_PICKING_BY_PART: "ACTIONS/CYCLE_COUNT/GET_STOCK_PICKING_BY_PART",
    EXPORT_PICKING_TO_PDF: "ACTIONS/CYCLE_COUNT/EXPORT_PICKING_TO_PDF",
    EXPORT_PICKING_TO_XLS: "ACTIONS/CYCLE_COUNT/EXPORT_PICKING_TO_XLS",
    SAVE_STOCK_RETURN: "ACTIONS/CYCLE_COUNT/SAVE_STOCK_RETURN",
  },
  DEPRECIATION: {
    METHODS: "ACTIONS/DEPRECIATION/METHODS",
    APPORTIONS: "ACTIONS/DEPRECIATION/APPORTIONS",
    LIST: "ACTIONS/DEPRECIATION/LIST",
    SAVE: "ACTIONS/DEPRECIATION/SAVE",
    DELETE: "ACTIONS/DEPRECIATION/DELETE",
    GET_USEFUL_LIST: "ACTIONS/DEPRECIATION/GET_USEFUL_LIST",

    GET_CONVENTION_PERCENTAGE_LIST:
      "ACTIONS/DEPRECIATION/GET_CONVENTION_PERCENTAGE_LIST",
    GET_CONVENTION_TYPE_LIST: "ACTIONS/DEPRECIATION/GET_CONVENTION_TYPE_LIST",
    GET_GAAP: "ACTIONS/DEPRECIATION/GET_GAAP",
    GET_REVALUATION_LIST: "ACTIONS/DEPRECIATION/GET_REVALUATION_LIST",
    GET_DISPOSAL_LIST: "ACTIONS/DEPRECIATION/GET_DISPOSAL_LIST",
    GET_MCARS_DEPRECIATION: "ACTIONS/DEPRECIATION/GET_MCARS_DEPRECIATION",
    SAVE_ASSET_DEPRECIATION: "ACTIONS/DEPRECIATION/SAVE_ASSET_DEPRECIATION",
    VALIDATE_MARS_TRANSACTION: "ACTIONS/DEPRECIATION/VALIDATE_MARS_TRANSACTION",
    GET_ASSET_BOOK_VALUE: "ACTIONS/DEPRECIATION/GET_ASSET_BOOK_VALUE",

    SAVE_REVALUATION: "ACTIONS/DEPRECIATION/SAVE_REVALUATION",
    SAVE_REVALUATION_ATTACHMENT:
      "ACTIONS/DEPRECIATION/SAVE_REVALUATION_ATTACHMENT",
    GET_DISPOSAL_TYPE_LIST: "ACTIONS/DEPRECIATION/GET_DISPOSAL_TYPE_LIST",
    SAVE_DISPOSAL: "ACTIONS/DEPRECIATION/SAVE_DISPOSAL",
    SAVE_DISPOSAL_ATTACHMENT: "ACTIONS/DEPRECIATION/SAVE_DISPOSAL_ATTACHMENT",
    GET_CURRET_USERFUL_LIFE: "ACTIONS/DEPRECIATION/GET_CURRET_USERFUL_LIFE",
    GET_ASSET_DEPRECIATION_LIST: "ACTIONS/DEPRECIATION/GET_ASSET_DEPRECIATION_LIST",
    ALL_ASSET_DEPRECIATION_EXPORT_TO_XLS: "ACTIONS/DEPRECIATION/ALL_ASSET_DEPRECIATION_EXPORT_TO_XLS",
    GET_DEPRECIATION_REPORT: "ACTIONS/DEPRECIATION/GET_DEPRECIATION_REPORT",
    DEPRECIATION_REPORT_EXPORT_TO_XLS: "ACTIONS/DEPRECIATION/DEPRECIATION_REPORT_EXPORT_TO_XLS",
    GET_AUDITOR_REPORT: "ACTIONS/DEPRECIATION/GET_AUDITOR_REPORT",
    AUDITOR_REPORT_EXPORT_TO_XLS: "ACTIONS/DEPRECIATION/AUDITOR_REPORT_EXPORT_TO_XLS",
  },

  WORK_REQUEST: {
    GET_WORK_REQUEST_LIST: "ACTIONS/WORK_REQUEST/GET_WORK_REQUEST_LIST",
    GET_STATUS_LIST: "ACTIONS/WORK_REQUEST/GET_STATUS_LIST",
    GET_PRIORITY_LIST: "ACTIONS/WORK_REQUEST/GET_PRIORITY_LIST",
    GET_CODE: "ACTIONS/WORK_REQUEST/GET_CODE",
    MOVE_STATUS: "ACTIONS/WORK_REQUEST/MOVE_STATUS",
    SAVE_WORK_REQUEST: "ACTIONS/WORK_REQUEST/SAVE_WORK_REQUEST",

    UPLOAD_IMAGE: "ACTIONS/WORK_REQUEST/UPLOAD_IMAGE",
    UPLOAD_ATTACHMENT: "ACTIONS/WORK_REQUEST/UPLOAD_ATTACHMENT",

    GET_WORK_REQUEST_BY_ID: "ACTIONS/WORK_REQUEST/GET_WORK_REQUEST_BY_ID",
    GET_ATTACHMENT: "ACTIONS/WORK_REQUEST/GET_ATTACHMENT",

    GET_IMAGES: "ACTIONS/WORK_REQUEST/GET_IMAGES",
    DELETE_WORK_REQUEST_FILES: "ACTIONS/WORK_REQUEST/DELETE_WORK_REQUEST_FILES",

    SAVE_WORK_REQUEST_NOTES: "ACTIONS/WORK_REQUEST/SAVE_WORK_REQUEST_NOTES",
    DELETE_WORK_REQUEST_NOTES: "ACTIONS/WORK_REQUEST/DELETE_WORK_REQUEST_NOTES",
    GET_WORK_REQUEST_NOTES_LIST:
      "ACTIONS/WORK_REQUEST/GET_WORK_REQUEST_NOTES_LIST",
    EXPORT_PDF: "ACTIONS/WORK_REQUEST/EXPORT_PDF",
    EXPORT_XLS: "ACTIONS/WORK_REQUEST/EXPORT_XLS",

    DELETE_WORK_REQUEST: "ACTIONS/WORK_REQUEST/DELETE_WORK_REQUEST",

    GET_LIST_FOR_KANBAN_VIEW: "ACTIONS/WORK_REQUEST/GET_LIST_FOR_KANBAN_VIEW", // New action for Kanban view
    WORK_REQUEST_PROCESS_AUDIO: "ACTIONS/WORK_REQUEST/WORK_REQUEST_PROCESS_AUDIO",
    WORK_REQUEST_PROCESS_FEEDBACK: "ACTIONS/WORK_REQUEST/WORK_REQUEST_PROCESS_FEEDBACK"
  },

  WORK_ORDER: {
    GET_WORK_STATUS_LIST: "ACTIONS/WORK_ORDER/GET_WORK_STATUS_LIST",
    GET_WORK_PRIORITY_LIST: "ACTIONS/WORK_ORDER/GET_WORK_PRIORITY_LIST",
    GET_WORK_MAINTENANCE_LIST: "ACTIONS/WORK_ORDER/GET_WORK_MAINTENANCE_LIST",
    GET_WORK_ASSIGNMENT_TYPE_LIST:
      "ACTIONS/WORK_ORDER/GET_WORK_ASSIGNMENT_TYPE_LIST",
    GET_WORK_CODE: "ACTIONS/WORK_ORDER/GET_WORK_CODE",
    GET_WORK_ORDER_LIST: "ACTIONS/WORK_ORDER/GET_WORK_ORDER_LIST",
    MOVE_STATUS: "ACTIONS/WORK_ORDER/MOVE_STATUS",
    GET_WORK_ORDER_BY_ID: "ACTIONS/WORK_ORDER/GET_WORK_ORDER_BY_ID",
    EXPORT_TO_PDF: "ACTIONS/WORK_ORDER/EXPORT_TO_PDF",
    EXPORT_TO_XLS: "ACTIONS/WORK_ORDER/EXPORT_TO_XLS",
    DELETE_WORK_ORDER: "ACTIONS/WORK_ORDER/DELETE_WORK_ORDER",
    GET_WORK_ATTACHMENT: "ACTIONS/WORK_ORDER/GET_WORK_ATTACHMENT",
    GET_WORK_IMAGES: "ACTIONS/WORK_ORDER/GET_WORK_IMAGES",
    DELETE_WORK_ORDER_FILES: "ACTIONS/WORK_ORDER/DELETE_WORK_ORDER_FILES",

    UPLOAD_IMAGE: "ACTIONS/WORK_ORDER/UPLOAD_IMAGE",
    UPLOAD_ATTACHMENT: "ACTIONS/WORK_ORDER/UPLOAD_ATTACHMENT",
    SAVE_WORK_ORDER: "ACTIONS/WORK_ORDER/SAVE_WORK_ORDER",
    SAVE_WORK_ORDER_TASK_DETAILS:
      "ACTIONS/WORK_ORDER/SAVE_WORK_ORDER_TASK_DETAILS",
    GET_WORK_ORDER_NOTE_LIST: "ACTIONS/WORK_ORDER/GET_WORK_ORDER_NOTE_LIST",
    SAVE_WORK_ORDER_NOTE_SAVE: "ACTIONS/WORK_ORDER/SAVE_WORK_ORDER_NOTE_SAVE",
    DELETE_WORK_ORDER_NOTE: "ACTIONS/WORK_ORDER/DELETE_WORK_ORDER_NOTE",
    GET_WORK_ORDER_TASK: "ACTIONS/WORK_ORDER/GET_WORK_ORDER_TASK",
    GET_WORK_ORDER_COMPLETION_BY_ID:
      "ACTIONS/WORK_ORDER/GET_WORK_ORDER_COMPLETION_BY_ID",
    GET_WORK_ORDER_COMPLETION_ATTACHMENTS:
      "ACTIONS/WORK_ORDER/GET_WORK_ORDER_COMPLETION_ATTACHMENTS",
    SAVE_WORK_ORDER_COMPLETION: "ACTIONS/WORK_ORDER/SAVE_WORK_ORDER_COMPLETION",
    SAVE_WORK_ORDER_COMPLETION_ATTACHMENT:
      "ACTIONS/WORK_ORDER/SAVE_WORK_ORDER_COMPLETION_ATTACHMENT",
    UPDATE_WORK_ORDER_INPROGRESS:
      "ACTIONS/WORK_ORDER/UPDATE_WORK_ORDER_INPROGRESS",
    UPDATE_WORK_ORDER_SCHEDULE: "ACTIONS/WORK_ORDER/UPDATE_WORK_ORDER_SCHEDULE",
    SAVE_WORK_ORDER_ASSETS: "ACTIONS/WORK_ORDER/SAVE_WORK_ORDER_ASSETS",
    SAVE_WORK_ORDER_INVENTORY: "ACTIONS/WORK_ORDER/SAVE_WORK_ORDER_INVENTORY",
    WORK_ORDER_STOCK_PICKING: "ACTIONS/WORK_ORDER/WORK_ORDER_STOCK_PICKING",


    SAVE_WORK_ORDER_ACTIVITY: "ACTIONS/WORK_ORDER/SAVE_WORK_ORDER_ACTIVITY",
    GET_WORK_ORDER_COMPLETION_LOG: "ACTIONS/WORK_ORDER/GET_WORK_ORDER_COMPLETION_LOG",
    GET_WORK_ORDER_TASK_LOG: "ACTIONS/WORK_ORDER/GET_WORK_ORDER_TASK_LOG",
    WO_TASK_LOG_EXPORT_TO_PDF: "ACTIONS/WORK_ORDER/WO_TASK_LOG_EXPORT_TO_PDF",
    WO_TASK_LOG_EXPORT_TO_XLS: "ACTIONS/WORK_ORDER/WO_TASK_LOG_EXPORT_TO_XLS",
    GET_WORK_ORDER_KANBAN_VIEW: "ACTIONS/WORK_ORDER/GET_WORK_ORDER_KANBAN_VIEW",
    RESCHEDULE_WORK_ORDER: "ACTIONS/WORK_ORDER/RESCHEDULE_WORK_ORDER",
    WORK_ORDER_SAVE_TASK_ATTACHMENTS: "ACTIONS/WORK_ORDER/WORK_ORDER_SAVE_TASK_ATTACHMENTS",
    WORK_ORDER_GET_PARTS_BY_WO_ID: "ACTIONS/WORK_ORDER/WORK_ORDER_GET_PARTS_BY_WO_ID",
    CHECK_WO_TASKS_COMPLETION: "ACTIONS/WORK_ORDER/CHECK_WO_TASKS_COMPLETION"

  },
  CHECKLIST: {
    GET_CHECKLIST_TYPES: "ACTIONS/CHECKLIST/GET_CHECKLIST_TYPES",
    GET_CHECKLIST_CODE: "ACTIONS/CHECKLIST/GET_CHECKLIST_CODE",
    GET_CHECKLISTS: "ACTIONS/CHECKLIST/GET_CHECKLISTS",
    GET_CHECKLIST_BY_ID: "ACTIONS/CHECKLIST/GET_CHECKLIST_BY_ID",
    GET_CHECKLIST_INPUT_TYPES: "ACTIONS/CHECKLIST/GET_CHECKLIST_INPUT_TYPES",
    SAVE_CHECKLIST: "ACTIONS/CHECKLIST/SAVE_CHECKLIST",
    SAVE_CHECKLIST_TASK: "ACTIONS/CHECKLIST/SAVE_CHECKLIST_TASK",
    SAVE_CHECKLIST_TASKS_ASSET_MAPPING:
      "ACTIONS/CHECKLIST/SAVE_CHECKLIST_TASKS_ASSET_MAPPING",
    GET_ASSETS_BY_CHECKLIST: "ACTIONS/CHECKLIST/GET_ASSETS_BY_CHECKLIST",
    DELETE_CHECKLIST: "ACTIONS/CHECKLIST/DELETE_CHECKLIST",
    DUPLICATE_CHECKLIST: "ACTIONS/CHECKLIST/DUPLICATE_CHECKLIST",
  },
  SAGE: {
    TEST_CONNECTION: "ACTIONS/SAGE/TEST_CONNECTION",
    SAVE_CONNECTION: "ACTIONS/SAGE/SAVE_CONNECTION",

    SYNC_ACCOUNT_GROUPS: "ACTIONS/SAGE/SYNC_ACCOUNT_GROUPS",
    SYNC_ACCOUNT: "ACTIONS/SAGE/SYNC_ACCOUNT",
    SYNC_FINANCIAL_BOOK: "ACTIONS/SAGE/SYNC_FINANCIAL_BOOK",
    SYNC_ITEM_GL: "ACTIONS/SAGE/SYNC_ITEM_GL",
    SYNC_LOCATION: "ACTIONS/SAGE/SYNC_LOCATION",
    SYNC_DEPARTMENT: "ACTIONS/SAGE/SYNC_DEPARTMENT",
    SYNC_VENDOR: "ACTIONS/SAGE/SYNC_VENDOR",

    GET_SYNC_ACCOUNT_GROUPS: "ACTIONS/SAGE/GET_SYNC_ACCOUNT_GROUPS",
    GET_SYNC_ACCOUNT: "ACTIONS/SAGE/GET_SYNC_ACCOUNT",
    GET_SYNC_FINANCIAL_BOOK: "ACTIONS/SAGE/GET_SYNC_FINANCIAL_BOOK",
    GET_SYNC_ITEM_GL: "ACTIONS/SAGE/GET_SYNC_ITEM_GL",
    GET_SAGE_FACILITY_LIST: "ACTIONS/SAGE/GET_SAGE_FACILITY_LIST",
    GET_SAGE_DEPARTMENT_LIST: "ACTIONS/SAGE/GET_SAGE_DEPARTMENT_LIST",

    GET_ASSET_SUB_GROUP_CODE: "ACTIONS/SAGE/GET_ASSET_SUB_GROUP_CODE",
    GET_ASSET_SUB_GROUP_LIST: "ACTIONS/SAGE/GET_ASSET_SUB_GROUP_LIST",
    SAVE_ASSET_SUB_GROUP: "ACTIONS/SAGE/SAVE_ASSET_SUB_GROUP",
    DELETE_ASSET_GROUP: "ACTIONS/SAGE/DELETE_ASSET_GROUP",

    GET_ASSET_MAPPING_LIST: "ACTIONS/SAGE/GET_ASSET_MAPPING_LIST",
    SAVE_ASSET_MAPPING: "ACTIONS/SAGE/SAVE_ASSET_MAPPING",

    GET_ASSET_INVENTORY_MAPPING_LIST:
      "ACTIONS/SAGE/GET_ASSET_INVENTORY_MAPPING_LIST",
    SAVE_ASSET_INVENTORY_MAPPING: "ACTIONS/SAGE/SAVE_ASSET_INVENTORY_MAPPING",

    GET_ASSET_OTHER_MAPPING_LIST: "ACTIONS/SAGE/GET_ASSET_OTHER_MAPPING_LIST",
    SAVE_ASSET_OTHER_MAPPING: "ACTIONS/SAGE/SAVE_ASSET_OTHER_MAPPING",
    SAVE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING: "ACTIONS/SAGE/SAVE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING",

    POST_ASSET_DISPOSAL_TO_SAGE: "ACTIONS/SAGE/POST_ASSET_DISPOSAL_TO_SAGE",
    POST_ASSET_REVALUATION_TO_SAGE: "ACTIONS/SAGE/POST_ASSET_REVALUATION_TO_SAGE",
    POST_ASSET_DEPRECIATION_TO_SAGE: "ACTIONS/SAGE/POST_ASSET_DEPRECIATION_TO_SAGE",

    GET_REF_NUMBER_LIST: "ACTIONS/SAGE/GET_REF_NUMBER_LIST",
    GET_DEFAULT_DATA_SYNC: "ACTIONS/SAGE/GET_DEFAULT_DATA_SYNC",
    GET_SAGE_CONFIG: "ACTIONS/SAGE/GET_SAGE_CONFIG",
    GET_SAGE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING_LIST: "ACTIONS/SAGE/GET_SAGE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING_LIST",
    GET_USED_ACCUMULATED_DEPRECIATION_ACCOUNT_LIST: "ACTIONS/SAGE/GET_USED_ACCUMULATED_DEPRECIATION_ACCOUNT_LIST",
    GET_USED_ACCOUNT_LIST: "ACTIONS/SAGE/GET_USED_ACCOUNT_LIST",
    POST_ALL: "ACTIONS/SAGE/POST_ALL",
    POST_ALL_STATUS: "ACTIONS/SAGE/POST_ALL_STATUS",
  },
  BILL_COM: {
    TEST_CONNECTION: "ACTIONS/BILL_COM/TEST_CONNECTION",
    SAVE_CONNECTION: "ACTIONS/BILL_COM/SAVE_CONNECTION",
    GET_BILL_COM_CONFIG: "ACTIONS/BILL_COM/GET_BILL_COM_CONFIG",
    SYNC_VENDOR: "ACTIONS/BILL_COM/SYNC_VENDOR",
    SYNC_DEPARTMENT: "ACTIONS/BILL_COM/SYNC_DEPARTMENT",
    GET_BILL_COM_VENDORS: "ACTIONS/BILL_COM/GET_BILL_COM_VENDORS",
    GET_BILL_COM_DEPARTMENTS: "ACTIONS/BILL_COM/GET_BILL_COM_DEPARTMENTS",
  },
  MAINTENANCE_CALENDER: {
    GET_FREQUENCY_LIST: "SAGA_ACTIONS/MAINTENANCE_CALENDER/GET_FREQUENCY_LIST",
    GET_SCHEDULER_CODE: "SAGA_ACTIONS/MAINTENANCE_CALENDER/GET_SCHEDULER_CODE",
    GET_SCHEDULER_TYPE: "SAGA_ACTIONS/MAINTENANCE_CALENDER/GET_SCHEDULER_TYPE",
    SAVE_SCHEDULER: "SAGA_ACTIONS/MAINTENANCE_CALENDER/SAVE_SCHEDULER",
    GET_SCHEDULER_LIST: "SAGA_ACTIONS/MAINTENANCE_CALENDER/GET_SCHEDULER_LIST",
    GET_SCHEDULER_BY_ID: "SAGA_ACTIONS/MAINTENANCE_CALENDER/GET_SCHEDULER_BY_ID",
    DELETE_SCHEDULER: "SAGA_ACTIONS/MAINTENANCE_CALENDER/DELETE_SCHEDULER",
    UPLOAD_IMAGE: "SAGA_ACTIONS/MAINTENANCE_CALENDER/UPLOAD_IMAGE",
    UPLOAD_ATTACHMENT: "SAGA_ACTIONS/MAINTENANCE_CALENDER/UPLOAD_ATTACHMENT",
    GET_SCHEDULER_ATTACHMENTS: "SAGA_ACTIONS/MAINTENANCE_CALENDER/GET_SCHEDULER_ATTACHMENTS",
    GET_SCHEDULER_IMAGES: "SAGA_ACTIONS/MAINTENANCE_CALENDER/GET_SCHEDULER_IMAGES",
    DELETE_SCHEDULER_FILES: "SAGA_ACTIONS/MAINTENANCE_CALENDER/DELETE_SCHEDULER_FILES",
    EXPORT_TO_PDF: "SAGA_ACTIONS/MAINTENANCE_CALENDER/EXPORT_TO_PDF",
    EXPORT_TO_XLS: "SAGA_ACTIONS/MAINTENANCE_CALENDER/EXPORT_TO_XLS",
  },
  PURCHASE_REQUEST: {
    GET_CODE: "SAGA_ACTIONS/PURCHASE_REQUEST/GET_CODE",
    GET_STATUSES: "SAGA_ACTIONS/PURCHASE_REQUEST/GET_STATUSES",
    GET_REQUEST_TYPES: "SAGA_ACTIONS/PURCHASE_REQUEST/GET_REQUEST_TYPES",
    LIST: "SAGA_ACTIONS/PURCHASE_REQUEST/LIST",
    GET_REQUEST_BY_ID: "SAGA_ACTIONS/PURCHASE_REQUEST/GET_REQUEST_BY_ID",
    SAVE: "SAGA_ACTIONS/PURCHASE_REQUEST/SAVE",
    DELETE: "SAGA_ACTIONS/PURCHASE_REQUEST/DELETE",
    EXPORT_TO_PDF: "SAGA_ACTIONS/PURCHASE_REQUEST/EXPORT_TO_PDF",
    EXPORT_TO_XLS: "SAGA_ACTIONS/PURCHASE_REQUEST/EXPORT_TO_XLS",
    PROCESS: "SAGA_ACTIONS/PURCHASE_REQUEST/PROCESS"


  },

  PURCHASE_ORDER: {
    GET_CODE: "SAGA_ACTIONS/PURCHASE_ORDER/GET_CODE",
    GET_STATUSES: "SAGA_ACTIONS/PURCHASE_ORDER/GET_STATUSES",
    GET_ORDER_TYPES: "SAGA_ACTIONS/PURCHASE_ORDER/GET_ORDER_TYPES",
    LIST: "SAGA_ACTIONS/PURCHASE_ORDER/LIST",
    GET_ORDER_BY_ID: "SAGA_ACTIONS/PURCHASE_ORDER/GET_ORDER_BY_ID",
    SAVE: "SAGA_ACTIONS/PURCHASE_ORDER/SAVE",
    SAVE_ORDER_FILE: "SAGA_ACTIONS/PURCHASE_ORDER/SAVE_ORDER_FILE",
    DELETE_ORDER_FILE: "SAGA_ACTIONS/PURCHASE_ORDER/DELETE_ORDER_FILE",
    DELETE: "SAGA_ACTIONS/PURCHASE_ORDER/DELETE",
    GET_FILES: "SAGA_ACTIONS/PURCHASE_ORDER/GET_FILES",
    EXPORT_TO_PDF: "SAGA_ACTIONS/PURCHASE_ORDER/EXPORT_TO_PDF",
    EXPORT_TO_XLS: "SAGA_ACTIONS/PURCHASE_ORDER/EXPORT_TO_XLS",
    PROCESS: "SAGA_ACTIONS/PURCHASE_ORDER/PROCESS",
    Save_Purchase_Order_From_PR: "SAGA_ACTIONS/PURCHASE_ORDER/Save_Purchase_Order_From_PR",


  },

  RECEIPT: {
    GET_RECEIPT_CODE: "SAGA_ACTIONS/RECEIPT/GET_RECEIPT_CODE",
    SAVE_PURCHASE_RECEIPT: "SAGA_ACTIONS/RECEIPT/SAVE_PURCHASE_RECEIPT",
    UPLOAD_ATTACHMENT: "SAGA_ACTIONS/RECEIPT/UPLOAD_ATTACHMENT",
    GET_RECEIPT_LIST: "SAGA_ACTIONS/RECEIPT/GET_RECEIPT_LIST",
    EXPORT_TO_PDF: "SAGA_ACTIONS/RECEIPT/EXPORT_TO_PDF",
    EXPORT_TO_XLS: "SAGA_ACTIONS/RECEIPT/EXPORT_TO_XLS",
    GET_RECEIPT_BY_ID: "SAGA_ACTIONS/RECEIPT/GET_RECEIPT_BY_ID",
    GET_RECEIPT_ATTACHMENTS: "SAGA_ACTIONS/RECEIPT/GET_RECEIPT_ATTACHMENTS",
    GET_PURCHASE_HISTORY_LIST: "SAGA_ACTIONS/RECEIPT/GET_PURCHASE_HISTORY_LIST"
  },

  VENDORS: {
    FILTERED_SERVICE_PROVIDER_LIST: "SAGA_ACTIONS/VENDORS/FILTERED_SERVICE_PROVIDER_LIST",
    REDUX_FILTERED_SERVICE_PROVIDER_LIST: "SAGA_ACTIONS/VENDORS/REDUX_FILTERED_SERVICE_PROVIDER_LIST",
    SAVE_VENDOR_DETAILS: "SAGA_ACTIONS/VENDORS/SAVE_VENDOR_DETAILS",
    GET_VENDOR_LIST: "SAGA_ACTIONS/VENDORS/GET_VENDOR_LIST",
    SAVE_VENDOR_FILES: "SAGA_ACTIONS/VENDORS/SAVE_VENDOR_FILES",
    GET_VENDOR_BY_ID: "SAGA_ACTIONS/VENDORS/GET_VENDOR_BY_ID",
    DELETE_VENDOR: "SAGA_ACTIONS/VENDORS/DELETE_VENDOR",
    GET_SERVICE_TYPE: "SAGA_ACTIONS/VENDORS/GET_SERVICE_TYPE",
    EXPORT_TO_CSV: "SAGA_ACTIONS/VENDORS/EXPORT_TO_CSV",
    EXPORT_TO_PDF: "SAGA_ACTIONS/VENDORS/EXPORT_TO_PDF",
    GET_VENDOR_ATTACHMENT: "SAGA_ACTIONS/VENDORS/GET_VENDOR_ATTACHMENT",
    GET_VENDOR_CODE: "SAGA_ACTIONS/VENDORS/GET_VENDOR_CODE"
  },
  DASHBOARD: {
    GET_ADOPTION_DASHBOARD_COUNTS: "SAGA_ACTIONS/DASHBOARD/GET_ADOPTION_DASHBOARD_COUNTS",
    EXPORT_ADOPTION_COUNTS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_ADOPTION_COUNTS_PDF",
    EXPORT_ADOPTION_COUNTS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_ADOPTION_COUNTS_XLS",
    EXPORT_KPI_TOTAL_WRS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_TOTAL_WRS_PDF",
    EXPORT_KPI_TOTAL_WRS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_TOTAL_WRS_XLS",
    EXPORT_KPI_AVG_TASKS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_AVG_TASKS_PDF",
    EXPORT_KPI_AVG_TASKS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_AVG_TASKS_XLS",
    GET_COMPLETED_WOS_WITHOUT_ROOT_CAUSE: "SAGA_ACTIONS/DASHBOARD/GET_COMPLETED_WOS_WITHOUT_ROOT_CAUSE",
    EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_PDF",
    EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_XLS",
    EXPORT_KPI_AVG_HOURS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_AVG_HOURS_PDF",
    EXPORT_KPI_AVG_HOURS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_AVG_HOURS_XLS",
    EXPORT_KPI_CHECKLIST_TASKS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_CHECKLIST_TASKS_PDF",
    EXPORT_KPI_CHECKLIST_TASKS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_CHECKLIST_TASKS_XLS",
    EXPORT_KPI_CHECKLIST_COMPLETION_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_CHECKLIST_COMPLETION_PDF",
    EXPORT_KPI_CHECKLIST_COMPLETION_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_KPI_CHECKLIST_COMPLETION_XLS",
    GET_WORK_REQUEST_ORIGINS: "SAGA_ACTIONS/DASHBOARD/GET_WORK_REQUEST_ORIGINS",
    GET_TASK_ORIGINS_GALLUS: "SAGA_ACTIONS/DASHBOARD/GET_TASK_ORIGINS_GALLUS",
    GET_GROWER_TASK_ORIGINS: "SAGA_ACTIONS/DASHBOARD/GET_GROWER_TASK_ORIGINS",
    GET_MY_DASHBOARD_PM_BY_FARM: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_PM_BY_FARM",
    GET_MY_DASHBOARD_PM_OVER_TIME: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_PM_OVER_TIME",
    GET_MY_DASHBOARD_REACTIVE_BY_FARM: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_REACTIVE_BY_FARM",
    GET_MY_DASHBOARD_REACTIVE_OVER_TIME: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_REACTIVE_OVER_TIME",
    EXPORT_MY_DASHBOARD_TO_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_TO_XLS",
    EXPORT_MY_DASHBOARD_TO_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_TO_PDF",
    EXPORT_MY_DASHBOARD_WR_OVER_TIME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WR_OVER_TIME_PDF",
    EXPORT_MY_DASHBOARD_WR_OVER_TIME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WR_OVER_TIME_XLS",
    EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_PDF",
    EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_XLS",
    EXPORT_MY_DASHBOARD_RESP_BY_FARM_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_RESP_BY_FARM_PDF",
    EXPORT_MY_DASHBOARD_RESP_BY_FARM_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_RESP_BY_FARM_XLS",
    EXPORT_MY_DASHBOARD_RESP_IND_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_RESP_IND_PDF",
    EXPORT_MY_DASHBOARD_RESP_IND_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_RESP_IND_XLS",
    EXPORT_MY_DASHBOARD_WALK_BY_FARM_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WALK_BY_FARM_PDF",
    EXPORT_MY_DASHBOARD_WALK_BY_FARM_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WALK_BY_FARM_XLS",
    EXPORT_MY_DASHBOARD_WALK_OVER_TIME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WALK_OVER_TIME_PDF",
    EXPORT_MY_DASHBOARD_WALK_OVER_TIME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WALK_OVER_TIME_XLS",
    EXPORT_MY_DASHBOARD_PM_BY_FARM_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_PM_BY_FARM_PDF",
    EXPORT_MY_DASHBOARD_PM_BY_FARM_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_PM_BY_FARM_XLS",
    EXPORT_MY_DASHBOARD_PM_OVER_TIME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_PM_OVER_TIME_PDF",
    EXPORT_MY_DASHBOARD_PM_OVER_TIME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_PM_OVER_TIME_XLS",
    EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_PDF",
    EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_XLS",
    EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_PDF",
    EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_XLS",
    GET_WR_STATUS_PIE_CHART: "SAGA_ACTIONS/DASHBOARD/GET_WR_STATUS_PIE_CHART",
    EXPORT_WR_STATUS_PIE_CHART_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_WR_STATUS_PIE_CHART_PDF",
    EXPORT_WR_STATUS_PIE_CHART_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_WR_STATUS_PIE_CHART_XLS",
    GET_USER_ACTIVITY_SUMMARY: "SAGA_ACTIONS/DASHBOARD/GET_USER_ACTIVITY_SUMMARY",
    GET_WR_COMPLETENESS_BY_FACILITY: "SAGA_ACTIONS/DASHBOARD/GET_WR_COMPLETENESS_BY_FACILITY",
    GET_STOCK_ADJUSTMENT_CHART: "SAGA_ACTIONS/DASHBOARD/GET_STOCK_ADJUSTMENT_CHART",
    GET_INVENTORY_MOVEMENT_CHART: "SAGA_ACTIONS/DASHBOARD/GET_INVENTORY_MOVEMENT_CHART",
    GET_CHECKLIST_BY_CREATOR: "SAGA_ACTIONS/DASHBOARD/GET_CHECKLIST_BY_CREATOR",
    EXPORT_CHECKLIST_BY_CREATOR_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_CHECKLIST_BY_CREATOR_PDF",
    EXPORT_CHECKLIST_BY_CREATOR_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_CHECKLIST_BY_CREATOR_XLS",
    GET_MANAGER_DASHBOARD_WR_KPIS: "SAGA_ACTIONS/DASHBOARD/GET_MANAGER_DASHBOARD_WR_KPIS",
    GET_MANAGER_DASHBOARD_WR: "SAGA_ACTIONS/DASHBOARD/GET_MANAGER_DASHBOARD_WR",
    GET_MANAGER_DASHBOARD_TEAM: "SAGA_ACTIONS/DASHBOARD/GET_MANAGER_DASHBOARD_TEAM",
    GET_MANAGER_DASHBOARD_PURCHASING: "SAGA_ACTIONS/DASHBOARD/GET_MANAGER_DASHBOARD_PURCHASING",
    GET_MANAGER_DASHBOARD_ASSETS: "SAGA_ACTIONS/DASHBOARD/GET_MANAGER_DASHBOARD_ASSETS",
    GET_RELIABILITY_MATRIX_DATA: "SAGA_ACTIONS/DASHBOARD/GET_RELIABILITY_MATRIX_DATA",
    GET_CLOSED_TASKS_REPORT: "SAGA_ACTIONS/DASHBOARD/GET_CLOSED_TASKS_REPORT",
    GET_ASSETS_UPTIME_REPORT: "SAGA_ACTIONS/DASHBOARD/GET_ASSETS_UPTIME_REPORT",
    GET_ASSETS_TIME_COST_REPORT: "SAGA_ACTIONS/DASHBOARD/GET_ASSETS_TIME_COST_REPORT",
    GET_WARRANTIES_REPORT: "SAGA_ACTIONS/DASHBOARD/GET_WARRANTIES_REPORT",
    GET_LOW_STOCK_REPORT: "SAGA_ACTIONS/DASHBOARD/GET_LOW_STOCK_REPORT",
    EXPORT_CLOSED_TASKS_REPORT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_CLOSED_TASKS_REPORT_XLS",
    EXPORT_ASSETS_UPTIME_REPORT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_ASSETS_UPTIME_REPORT_XLS",
    EXPORT_ASSETS_TIME_COST_REPORT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_ASSETS_TIME_COST_REPORT_XLS",
    EXPORT_WARRANTIES_REPORT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_WARRANTIES_REPORT_XLS",
    EXPORT_LOW_STOCK_REPORT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOW_STOCK_REPORT_XLS",
    EXPORT_WORK_REQUEST_ORIGINS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_WORK_REQUEST_ORIGINS_PDF",
    EXPORT_WORK_REQUEST_ORIGINS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_WORK_REQUEST_ORIGINS_XLS",
    EXPORT_GROWER_TASK_ORIGINS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_GROWER_TASK_ORIGINS_PDF",
    EXPORT_GROWER_TASK_ORIGINS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_GROWER_TASK_ORIGINS_XLS",
    EXPORT_USER_ACTIVITY_SUMMARY_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_USER_ACTIVITY_SUMMARY_PDF",
    EXPORT_USER_ACTIVITY_SUMMARY_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_USER_ACTIVITY_SUMMARY_XLS",
    EXPORT_WR_COMPLETENESS_BY_FACILITY_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_WR_COMPLETENESS_BY_FACILITY_PDF",
    EXPORT_WR_COMPLETENESS_BY_FACILITY_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_WR_COMPLETENESS_BY_FACILITY_XLS",
    EXPORT_STOCK_ADJUSTMENT_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_STOCK_ADJUSTMENT_PDF",
    EXPORT_STOCK_ADJUSTMENT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_STOCK_ADJUSTMENT_XLS",
    EXPORT_INVENTORY_MOVEMENT_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_INVENTORY_MOVEMENT_PDF",
    EXPORT_INVENTORY_MOVEMENT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_INVENTORY_MOVEMENT_XLS",
    EXPORT_MANAGER_WORK_REQUESTS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_WORK_REQUESTS_PDF",
    EXPORT_MANAGER_WORK_REQUESTS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_WORK_REQUESTS_XLS",
    EXPORT_MANAGER_PURCHASING_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_PURCHASING_PDF",
    EXPORT_MANAGER_PURCHASING_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_PURCHASING_XLS",
    EXPORT_TASK_ORIGINS_GALLUS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASK_ORIGINS_GALLUS_PDF",
    EXPORT_TASK_ORIGINS_GALLUS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASK_ORIGINS_GALLUS_XLS",
    GET_MY_DASHBOARD_WR_OVER_TIME: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_WR_OVER_TIME",
    GET_MY_DASHBOARD_WR_BY_FACILITY_OVER_TIME: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_WR_BY_FACILITY_OVER_TIME",
    EXPORT_MY_DASHBOARD_WR_BY_FACILITY_OT_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WR_BY_FACILITY_OT_PDF",
    EXPORT_MY_DASHBOARD_WR_BY_FACILITY_OT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WR_BY_FACILITY_OT_XLS",
    GET_MY_DASHBOARD_TASKS_BY_FACILITY_OVER_TIME: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_TASKS_BY_FACILITY_OVER_TIME",
    EXPORT_MY_DASHBOARD_TASKS_BY_FACILITY_OT_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_TASKS_BY_FACILITY_OT_PDF",
    EXPORT_MY_DASHBOARD_TASKS_BY_FACILITY_OT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_TASKS_BY_FACILITY_OT_XLS",
    GET_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM",
    EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM_PDF",
    EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM_XLS",
    GET_MY_DASHBOARD_WR_COMPLETENESS_BY_ME: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_WR_COMPLETENESS_BY_ME",
    EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_ME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_ME_PDF",
    EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_ME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_ME_XLS",
    GET_MY_DASHBOARD_TASKS_OVER_TIME: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_TASKS_OVER_TIME",
    GET_MY_DASHBOARD_RESPONSIVENESS_BY_FARM: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_RESPONSIVENESS_BY_FARM",
    GET_MY_DASHBOARD_RESPONSIVENESS_INDIVIDUAL: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_RESPONSIVENESS_INDIVIDUAL",
    GET_MY_DASHBOARD_WALKTHROUGHS_BY_FARM: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_WALKTHROUGHS_BY_FARM",
    GET_MY_DASHBOARD_WALKTHROUGHS_OVER_TIME: "SAGA_ACTIONS/DASHBOARD/GET_MY_DASHBOARD_WALKTHROUGHS_OVER_TIME",
    GET_MANAGER_HOURS_BY_FACILITY: "SAGA_ACTIONS/DASHBOARD/GET_MANAGER_HOURS_BY_FACILITY",
    EXPORT_MANAGER_HOURS_BY_FACILITY_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_HOURS_BY_FACILITY_PDF",
    EXPORT_MANAGER_HOURS_BY_FACILITY_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_HOURS_BY_FACILITY_XLS",
    GET_MANAGER_HOURS_BY_FACILITY_LP: "SAGA_ACTIONS/DASHBOARD/GET_MANAGER_HOURS_BY_FACILITY_LP",
    EXPORT_MANAGER_HOURS_BY_FACILITY_LP_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_HOURS_BY_FACILITY_LP_PDF",
    EXPORT_MANAGER_HOURS_BY_FACILITY_LP_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_HOURS_BY_FACILITY_LP_XLS",
    GET_MANAGER_HOURS_BY_FACILITY_RM: "SAGA_ACTIONS/DASHBOARD/GET_MANAGER_HOURS_BY_FACILITY_RM",
    EXPORT_MANAGER_HOURS_BY_FACILITY_RM_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_HOURS_BY_FACILITY_RM_PDF",
    EXPORT_MANAGER_HOURS_BY_FACILITY_RM_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_HOURS_BY_FACILITY_RM_XLS",
    EXPORT_TASKS_AGING_PRIORITY_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASKS_AGING_PRIORITY_PDF",
    EXPORT_TASKS_AGING_PRIORITY_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASKS_AGING_PRIORITY_XLS",
    EXPORT_WR_BY_PRIORITY_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_WR_BY_PRIORITY_PDF",
    EXPORT_WR_BY_PRIORITY_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_WR_BY_PRIORITY_XLS",
    EXPORT_TASK_FUNNEL_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASK_FUNNEL_PDF",
    EXPORT_TASK_FUNNEL_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASK_FUNNEL_XLS",
    EXPORT_HIGH_PRI_WRS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_HIGH_PRI_WRS_PDF",
    EXPORT_HIGH_PRI_WRS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_HIGH_PRI_WRS_XLS",
    EXPORT_TASK_CREATION_TIME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASK_CREATION_TIME_PDF",
    EXPORT_TASK_CREATION_TIME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASK_CREATION_TIME_XLS",
    EXPORT_TASK_COMPLETION_TIME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASK_COMPLETION_TIME_PDF",
    EXPORT_TASK_COMPLETION_TIME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASK_COMPLETION_TIME_XLS",
    EXPORT_COMPLETED_TASKS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_PDF",
    EXPORT_COMPLETED_TASKS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_XLS",
    GET_COMPLETED_TASKS_BY_FARM: "SAGA_ACTIONS/DASHBOARD/GET_COMPLETED_TASKS_BY_FARM",
    EXPORT_COMPLETED_TASKS_BY_FARM_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_BY_FARM_PDF",
    EXPORT_COMPLETED_TASKS_BY_FARM_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_BY_FARM_XLS",
    GET_COMPLETED_TASKS_BY_RM: "SAGA_ACTIONS/DASHBOARD/GET_COMPLETED_TASKS_BY_RM",
    EXPORT_COMPLETED_TASKS_BY_RM_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_BY_RM_PDF",
    EXPORT_COMPLETED_TASKS_BY_RM_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_BY_RM_XLS",
    GET_COMPLETED_TASKS_BY_LP: "SAGA_ACTIONS/DASHBOARD/GET_COMPLETED_TASKS_BY_LP",
    EXPORT_COMPLETED_TASKS_BY_LP_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_BY_LP_PDF",
    EXPORT_COMPLETED_TASKS_BY_LP_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_BY_LP_XLS",
    GET_COMPLETED_TASKS_BY_GROWER: "SAGA_ACTIONS/DASHBOARD/GET_COMPLETED_TASKS_BY_GROWER",
    EXPORT_COMPLETED_TASKS_BY_GROWER_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_BY_GROWER_PDF",
    EXPORT_COMPLETED_TASKS_BY_GROWER_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_COMPLETED_TASKS_BY_GROWER_XLS",
    GET_LOGGED_HOURS_BY_RM: "SAGA_ACTIONS/DASHBOARD/GET_LOGGED_HOURS_BY_RM",
    EXPORT_LOGGED_HOURS_BY_RM_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOGGED_HOURS_BY_RM_PDF",
    EXPORT_LOGGED_HOURS_BY_RM_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOGGED_HOURS_BY_RM_XLS",
    GET_LOGGED_HOURS_BY_LP: "SAGA_ACTIONS/DASHBOARD/GET_LOGGED_HOURS_BY_LP",
    EXPORT_LOGGED_HOURS_BY_LP_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOGGED_HOURS_BY_LP_PDF",
    EXPORT_LOGGED_HOURS_BY_LP_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOGGED_HOURS_BY_LP_XLS",
    GET_LOGGED_HOURS_BY_GROWER: "SAGA_ACTIONS/DASHBOARD/GET_LOGGED_HOURS_BY_GROWER",
    EXPORT_LOGGED_HOURS_BY_GROWER_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOGGED_HOURS_BY_GROWER_PDF",
    EXPORT_LOGGED_HOURS_BY_GROWER_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOGGED_HOURS_BY_GROWER_XLS",
    EXPORT_LOGGED_HOURS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOGGED_HOURS_PDF",
    EXPORT_LOGGED_HOURS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOGGED_HOURS_XLS",
    EXPORT_PM_REACTIVE_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_PM_REACTIVE_PDF",
    EXPORT_PM_REACTIVE_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_PM_REACTIVE_XLS",
    GET_PURCHASING_METHOD_BY_WO: "SAGA_ACTIONS/DASHBOARD/GET_PURCHASING_METHOD_BY_WO",
    EXPORT_PURCHASING_METHOD_COUNT_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASING_METHOD_COUNT_PDF",
    EXPORT_PURCHASING_METHOD_COUNT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASING_METHOD_COUNT_XLS",
    EXPORT_PURCHASING_METHOD_VALUE_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASING_METHOD_VALUE_PDF",
    EXPORT_PURCHASING_METHOD_VALUE_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASING_METHOD_VALUE_XLS",
    EXPORT_PURCHASING_METHOD_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASING_METHOD_PDF",
    EXPORT_PURCHASING_METHOD_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASING_METHOD_XLS",
    EXPORT_PURCHASING_SPEND_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASING_SPEND_PDF",
    EXPORT_PURCHASING_SPEND_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASING_SPEND_XLS",
    EXPORT_GOODS_ON_ORDER_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_GOODS_ON_ORDER_PDF",
    EXPORT_GOODS_ON_ORDER_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_GOODS_ON_ORDER_XLS",
    EXPORT_PURCHASE_RECEIPTS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASE_RECEIPTS_PDF",
    EXPORT_PURCHASE_RECEIPTS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_PURCHASE_RECEIPTS_XLS",
    EXPORT_LOW_INVENTORY_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOW_INVENTORY_PDF",
    EXPORT_LOW_INVENTORY_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_LOW_INVENTORY_XLS",
    EXPORT_DOWN_ASSETS_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_DOWN_ASSETS_PDF",
    EXPORT_DOWN_ASSETS_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_DOWN_ASSETS_XLS",
    EXPORT_ASSET_DOWNTIME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_ASSET_DOWNTIME_PDF",
    EXPORT_ASSET_DOWNTIME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_ASSET_DOWNTIME_XLS",
    EXPORT_MTTR_MTBF_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MTTR_MTBF_PDF",
    EXPORT_MTTR_MTBF_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MTTR_MTBF_XLS",
    EXPORT_RELIABILITY_MATRIX_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_RELIABILITY_MATRIX_PDF",
    EXPORT_RELIABILITY_MATRIX_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_RELIABILITY_MATRIX_XLS",
    EXPORT_EXPIRING_WARRANTIES_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_EXPIRING_WARRANTIES_PDF",
    EXPORT_EXPIRING_WARRANTIES_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_EXPIRING_WARRANTIES_XLS",
    GET_WRS_WITHOUT_TASK_BY_PRIORITY: "SAGA_ACTIONS/DASHBOARD/GET_WRS_WITHOUT_TASK_BY_PRIORITY",
    EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_PDF",
    EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_XLS",
    EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_PDF",
    EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_XLS",
    EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_PDF",
    EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_XLS",
    EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_PDF",
    EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_XLS",
    EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_PDF",
    EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_XLS",
    GET_SCHEDULED_TASKS_BY_FACILITY: "SAGA_ACTIONS/DASHBOARD/GET_SCHEDULED_TASKS_BY_FACILITY",
    EXPORT_SCHEDULED_TASKS_DETAIL_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_SCHEDULED_TASKS_DETAIL_PDF",
    EXPORT_SCHEDULED_TASKS_DETAIL_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_SCHEDULED_TASKS_DETAIL_XLS",
    GET_TASKS_AND_WRS_BY_FACILITY: "SAGA_ACTIONS/DASHBOARD/GET_TASKS_AND_WRS_BY_FACILITY",
    EXPORT_TASKS_AND_WRS_BY_PRIORITY_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASKS_AND_WRS_BY_PRIORITY_PDF",
    EXPORT_TASKS_AND_WRS_BY_PRIORITY_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_TASKS_AND_WRS_BY_PRIORITY_XLS",
    GET_TOTAL_RESPONSE_TIME: "SAGA_ACTIONS/DASHBOARD/GET_TOTAL_RESPONSE_TIME",
    EXPORT_TOTAL_RESPONSE_TIME_PDF: "SAGA_ACTIONS/DASHBOARD/EXPORT_TOTAL_RESPONSE_TIME_PDF",
    EXPORT_TOTAL_RESPONSE_TIME_XLS: "SAGA_ACTIONS/DASHBOARD/EXPORT_TOTAL_RESPONSE_TIME_XLS",
  }
};
